/*
  Blackfield — interactions des sections "bf-*" (header, tiroir mobile,
  mega-menu, carrousel a onglets, lookbook, comparateur de tailles).
  Port fidele du comportement de "Blackfield Home.dc.html" (onMouseEnter /
  onMouseLeave / onClick sur openDrawer, closeDrawer, closeMega).
*/
(function () {
  'use strict';

  function initHeader(root) {
    var overlay = root.querySelector('[data-bf-drawer-overlay]');
    var openBtn = root.querySelector('[data-bf-drawer-open]');
    var closeBtn = root.querySelector('[data-bf-drawer-close]');
    if (openBtn && overlay) {
      openBtn.addEventListener('click', function () { overlay.classList.add('is-open'); });
    }
    if (closeBtn && overlay) {
      closeBtn.addEventListener('click', function () { overlay.classList.remove('is-open'); });
    }
    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) overlay.classList.remove('is-open');
      });
    }

    // Tiroir mobile : depliage des sous-niveaux (niveau 2 + niveau 3)
    root.querySelectorAll('[data-bf-drawer-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var key = toggle.getAttribute('data-bf-drawer-toggle');
        var sub = root.querySelector('[data-bf-drawer-sub="' + key + '"]');
        if (sub) sub.classList.toggle('is-open');
      });
    });

    var navItems = root.querySelectorAll('[data-bf-nav-item]');
    var megaPanels = root.querySelectorAll('[data-bf-mega]');
    var closeTimer = null;

    // Le panneau ferme est en visibility:hidden (pas display:none, sinon pas de
    // transition). Chrome SUSPEND l'autoplay d'une video non rendue : sans ce
    // play() explicite, une video promo ne demarrerait jamais. On met en pause
    // a la fermeture pour ne pas decoder dans le vide.
    function videosMega(panel, ouvert) {
      panel.querySelectorAll('video').forEach(function (v) {
        if (ouvert) {
          var p = v.play();
          // play() rejette si le navigateur refuse l'autoplay : on avale, sinon
          // la console se remplit d'erreurs non gerees.
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          v.pause();
        }
      });
    }

    function openMega(index) {
      clearTimeout(closeTimer);
      megaPanels.forEach(function (panel) {
        var ouvert = panel.getAttribute('data-bf-mega') === String(index);
        panel.classList.toggle('is-open', ouvert);
        videosMega(panel, ouvert);
      });
      root.querySelectorAll('[data-bf-nav-trigger]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', trigger.getAttribute('data-bf-nav-trigger') === String(index) ? 'true' : 'false');
      });
    }

    function closeMega() {
      closeTimer = setTimeout(function () {
        megaPanels.forEach(function (panel) { panel.classList.remove('is-open'); videosMega(panel, false); });
        root.querySelectorAll('[data-bf-nav-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }, 120);
    }

    navItems.forEach(function (item) {
      var trigger = item.querySelector('[data-bf-nav-trigger]');
      if (!trigger) return;
      var index = trigger.getAttribute('data-bf-nav-trigger');
      item.addEventListener('mouseenter', function () { openMega(index); });
      item.addEventListener('mouseleave', closeMega);
    });
    megaPanels.forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', closeMega);
    });
  }

  function initReassurance() {
    // Le contenu du tiroir est reconstruit a chaque modification du panier :
    // on ne garde donc aucune reference aux elements, on les retrouve a chaque
    // battement et tout l'etat vit dans des attributs.
    // Un seul intervalle, mais chaque bloc avance a SA vitesse : le tiroir du
    // panier et la fiche produit ont chacun leur reglage. Le temps ecoule de
    // chaque bloc est range dans data-bf-reass-t.
    var PAS = 250;
    setInterval(function () {
      document.querySelectorAll('[data-bf-reass]').forEach(function (box) {
        var liste = box.querySelector('[data-bf-reass-list]') || box.querySelector('.bf-cartd__reass-list');
        if (!liste || liste.children.length < 2) return;
        var delai = (parseFloat(box.getAttribute('data-bf-reass-delay')) || 3) * 1000;
        var t = (parseInt(box.getAttribute('data-bf-reass-t') || '0', 10) || 0) + PAS;
        if (t < delai) { box.setAttribute('data-bf-reass-t', String(t)); return; }
        box.setAttribute('data-bf-reass-t', '0');
        var n = liste.children.length;
        var h = box.clientHeight || 20;
        var i = (parseInt(box.getAttribute('data-bf-reass-i') || '0', 10) + 1) % n;
        box.setAttribute('data-bf-reass-i', i);
        liste.style.transform = 'translateY(' + (-i * h) + 'px)';
      });
    }, PAS);
  }

  // Menu collant : marque le body des que la page a defile, pour que
  // l'en-tete se detache par une ombre. Et bouton de retour en haut.
  function initStickyEtToTop() {
    var btn = document.querySelector('[data-bf-totop]');
    if (btn) btn.removeAttribute('hidden');
    var maj = function () {
      var y = window.scrollY || window.pageYOffset || 0;
      document.body.classList.toggle('bf-scrolled', y > 20);
      if (btn) btn.classList.toggle('is-on', y > 700);
    };
    window.addEventListener('scroll', maj, { passive: true });
    maj();
    if (!btn) return;
    btn.addEventListener('click', function () {
      var depart = window.scrollY || 0;
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      catch (e) { window.scrollTo(0, 0); }
      setTimeout(function () {
        if (Math.abs((window.scrollY || 0) - depart) < 2) window.scrollTo(0, 0);
      }, 380);
    });
  }

  // Colonnes depliables du pied de page (mobile). Sur ordinateur le CSS
  // neutralise le bouton : inutile de conditionner le JS a la largeur.
  function initFooterCols() {
    document.querySelectorAll('[data-bf-fcol-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.closest('[data-bf-fcol]');
        if (!col) return;
        var ouvert = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      });
    });
  }

  // Agrandissement des images de la page produit : une fenetre par-dessus la
  // page, avec passage d'une image a l'autre par points, fleches, clavier ou
  // glissement du doigt.
  function initZoom() {
    var vignettes = [].slice.call(document.querySelectorAll('[data-bf-zoom]'));
    if (!vignettes.length) return;
    var sources = vignettes.map(function (v) {
      // on garde la figure : c'est elle qui porte l'image DEJA chargee par la
      // page, et c'est cette image-la qu'on affichera sans attendre.
      return { url: v.getAttribute('data-bf-zoom'), alt: v.getAttribute('data-bf-zoom-alt') || '', fig: v };
    });
    var index = 0, declencheur = null;

    // Largeur demandee au CDN, calee sur l'ecran. Mesure : 2000 px sur un
    // telephone de 375 = 293 Ko et 768 ms, pour cinq fois plus de pixels que
    // l'ecran ne peut en montrer. Arrondi a 200 px pres : moins de variantes
    // demandees, donc plus de chances que le CDN reponde depuis son cache.
    var largeurZoom = (function () {
      var w = Math.round((window.innerWidth || 1000) * (window.devicePixelRatio || 1) * 1.15);
      if (w < 800) { w = 800; }
      if (w > 2000) { w = 2000; }
      return Math.ceil(w / 200) * 200;
    })();
    var aLargeur = function (u, w) {
      return /([?&]width=)\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u;
    };
    var dejaChargee = function (s) {
      var im = s.fig && s.fig.querySelector('img');
      return im && im.currentSrc ? im.currentSrc : '';
    };

    var ov = document.createElement('div');
    ov.className = 'bf-zoom';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Image agrandie');
    ov.innerHTML =
      // Compteur, croix et points sont DANS le cadre : sans voile plein ecran,
      // ils flotteraient au milieu de la fiche au lieu de rester colles a la
      // photo. Le pop-up ne doit couvrir que l'image.
      '<div class="bf-zoom__stage">' +
        '<span class="bf-zoom__compteur" data-bf-zc></span>' +
        '<button type="button" class="bf-zoom__btn bf-zoom__close" aria-label="Fermer">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<button type="button" class="bf-zoom__btn bf-zoom__prev" aria-label="Image precedente">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<img class="bf-zoom__img" alt="">' +
        '<button type="button" class="bf-zoom__btn bf-zoom__next" aria-label="Image suivante">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div class="bf-zoom__dots" data-bf-zd></div>' +
      '</div>';
    document.body.appendChild(ov);

    var img = ov.querySelector('.bf-zoom__img');
    var dots = ov.querySelector('[data-bf-zd]');
    var compteur = ov.querySelector('[data-bf-zc]');
    var prev = ov.querySelector('.bf-zoom__prev');
    var next = ov.querySelector('.bf-zoom__next');

    sources.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'bf-zoom__dot';
      d.setAttribute('aria-label', 'Image ' + (i + 1) + ' sur ' + sources.length);
      d.addEventListener('click', function () { montrer(i); });
      dots.appendChild(d);
    });
    if (sources.length < 2) { dots.hidden = true; prev.hidden = true; next.hidden = true; }

    function montrer(i) {
      index = (i + sources.length) % sources.length;
      var s = sources[index];
      var grande = aLargeur(s.url, largeurZoom);
      var apercu = dejaChargee(s);

      // 1. La version deja chargee par la page s'affiche TOUT DE SUITE : elle
      //    est en cache, donc aucune attente et pas un octet de plus. La
      //    fenetre n'est jamais vide.
      img.src = apercu || grande;
      img.alt = s.alt;

      // 2. La version nette arrive derriere et remplace -- mais seulement si on
      //    est toujours sur la meme image : en cliquant vite sur la fleche, une
      //    image en retard viendrait sinon ecraser la suivante.
      if (apercu && grande !== apercu) {
        var attendu = index;
        var haute = new Image();
        haute.onload = function () { if (attendu === index) { img.src = grande; } };
        haute.src = grande;
      }

      compteur.textContent = (index + 1) + ' / ' + sources.length;
      for (var k = 0; k < dots.children.length; k++) {
        dots.children[k].classList.toggle('is-active', k === index);
      }

      // 3. Les deux voisines sont preparees : la fleche suivante est immediate.
      if (sources.length > 1) {
        [index - 1, index + 1].forEach(function (n) {
          var v = sources[(n + sources.length) % sources.length];
          if (v && v !== s) { var p = new Image(); p.src = aLargeur(v.url, largeurZoom); }
        });
      }
    }
    function ouvrir(i, depuis) {
      declencheur = depuis || null;
      montrer(i);
      ov.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      ov.querySelector('.bf-zoom__close').focus();
    }
    function fermer() {
      ov.classList.remove('is-open');
      document.body.style.overflow = '';
      if (declencheur && declencheur.focus) declencheur.focus();
    }

    vignettes.forEach(function (v, i) {
      v.addEventListener('click', function () { ouvrir(i, v); });
      v.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ouvrir(i, v); }
      });
    });
    ov.querySelector('.bf-zoom__close').addEventListener('click', fermer);
    prev.addEventListener('click', function () { montrer(index - 1); });
    next.addEventListener('click', function () { montrer(index + 1); });
    ov.addEventListener('click', function (e) {
      if (e.target === ov || (e.target.classList && e.target.classList.contains('bf-zoom__stage'))) fermer();
    });
    document.addEventListener('keydown', function (e) {
      if (!ov.classList.contains('is-open')) return;
      if (e.key === 'Escape') fermer();
      else if (e.key === 'ArrowLeft') montrer(index - 1);
      else if (e.key === 'ArrowRight') montrer(index + 1);
    });
    var x0 = null;
    ov.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    ov.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) montrer(index + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    // Les miniatures de la barre d'achat ouvrent la meme fenetre.
    document.querySelectorAll('[data-bf-zoom-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        ouvrir(parseInt(b.getAttribute('data-bf-zoom-open'), 10) || 0, b);
      });
    });

    ov._bfOuvrir = ouvrir;
  }

  // Carrousel a points. Sur mobile une seule fiche par vue, en pleine
  // largeur ; sur ordinateur autant que le reglage "Fiches visibles".
  // Pas de fleches : la pagination se fait aux points, ou au doigt.
  function initRailCarousel(rail) {
    var dots = rail.parentNode.querySelector('[data-bf-dots]');
    // La liste est relue a chaque fois : certains carrousels (le tiroir du
    // panier) voient leur contenu regenere apres coup.
    function items() {
      return [].slice.call(rail.children).filter(function (c) {
        return c.classList && (c.classList.contains('bf-card')
          || c.classList.contains('bf-pdp__media-item')
          || c.classList.contains('bf-cartd__reco-item')
          || c.classList.contains('bf-review'));
      });
    }
    var cartes = items();
    if (!cartes.length) return;
    // Deja installe : on se contente de recalculer.
    if (rail._bfInit) { rail._bfRefresh(); return; }
    rail._bfInit = true;

    var timer = null;
    var abandonne = false;

    function pas() {
      var l = items();
      if (l.length > 1) {
        var d = l[1].offsetLeft - l[0].offsetLeft;
        if (d > 0) return d;
      }
      return (l[0] && l[0].offsetWidth) || rail.clientWidth;
    }
    function parVue() { return Math.max(1, Math.round(rail.clientWidth / pas())); }
    function nbPages() { return Math.max(1, Math.ceil(items().length / parVue())); }
    function pageCourante() {
      var p = pas() * parVue();
      if (!p) return 0;
      return Math.max(0, Math.min(nbPages() - 1, Math.round(rail.scrollLeft / p)));
    }
    function versPage(i) {
      var cible = i * pas() * parVue();
      var depart = rail.scrollLeft;
      // Mouvement reduit : on va au but sans animer, mais le carrousel
      // continue de defiler.
      var doux = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      try { rail.scrollTo({ left: cible, behavior: doux ? 'smooth' : 'auto' }); }
      catch (e) { rail.scrollLeft = cible; }
      // Filet : certains navigateurs ignorent le defilement doux.
      setTimeout(function () {
        if (Math.abs(rail.scrollLeft - depart) < 2 && Math.abs(cible - depart) > 2) {
          rail.scrollLeft = cible;
        }
      }, 380);
      marquerDot(i);
    }

    function construireDots(n) {
      if (!dots) return;
      dots.innerHTML = '';
      dots.classList.toggle('bf-rail-dots--dense', n > 9);
      dots.hidden = n < 2;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bf-rail-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Page ' + (i + 1) + ' sur ' + n);
        (function (idx) {
          b.addEventListener('click', function () { abandon(); versPage(idx); });
        })(i);
        dots.appendChild(b);
      }
    }
    function marquerDot(actif) {
      if (!dots) return;
      for (var i = 0; i < dots.children.length; i++) {
        var on = i === actif;
        dots.children[i].classList.toggle('is-active', on);
        dots.children[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }
    function majDots() {
      if (!dots || !rail.clientWidth) return;
      var n = nbPages();
      if (dots.children.length !== n) construireDots(n);
      marquerDot(pageCourante());
    }

    function visible() {
      var p = rail.closest ? rail.closest('.bf-tab-panel') : null;
      return !p || p.classList.contains('is-active');
    }
    function suivante() {
      var i = pageCourante() + 1;
      if (i >= nbPages()) i = 0;
      versPage(i);
    }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }
    function abandon() { abandonne = true; pause(); }
    function demarrer() {
      pause();
      if (abandonne || !visible()) return;
      if (rail.getAttribute('data-bf-auto') !== '1') return;
      if (nbPages() < 2) return;
      var delai = parseFloat(rail.getAttribute('data-bf-delay') || '5') * 1000;
      timer = setInterval(suivante, delai);
    }

    // Des que le visiteur prend la main, on n'insiste plus.
    rail.addEventListener('touchstart', abandon, { passive: true });
    rail.addEventListener('mousedown', abandon);
    rail.addEventListener('focusin', abandon);
    rail.addEventListener('mouseenter', pause);
    rail.addEventListener('mouseleave', demarrer);

    var tScroll = null;
    rail.addEventListener('scroll', function () {
      if (tScroll) clearTimeout(tScroll);
      tScroll = setTimeout(majDots, 90);
    }, { passive: true });

    var tResize = null;
    window.addEventListener('resize', function () {
      if (tResize) clearTimeout(tResize);
      tResize = setTimeout(function () { construireDots(nbPages()); majDots(); }, 200);
    });

    rail._bfRefresh = function () { majDots(); demarrer(); };
    rail._bfPause = pause;
    majDots();
    demarrer();
  }

  function initProductTabs(section) {
    var tabs = section.querySelectorAll('[data-bf-tab]');
    var panels = section.querySelectorAll('[data-bf-panel]');
    if (!tabs.length) return;

    // Le trait glisse sous l'onglet actif. On mesure en coordonnees internes
    // a la barre (offsetLeft) : la barre defile horizontalement sur mobile,
    // des coordonnees ecran seraient fausses des qu'on la fait glisser.
    var barre = section.querySelector('.bf-tabs');
    var ind = section.querySelector('[data-bf-tab-ind]');
    function placerIndicateur() {
      if (!ind || !barre) return;
      var actif = barre.querySelector('.bf-tab.is-active') || tabs[0];
      if (!actif) return;
      ind.style.width = actif.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + actif.offsetLeft + 'px)';
    }
    var tPlace = null;
    window.addEventListener('resize', function () {
      if (tPlace) clearTimeout(tPlace);
      tPlace = setTimeout(placerIndicateur, 150);
    });
    // Les polices arrivent parfois apres le premier calcul : on repasse.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placerIndicateur);
    placerIndicateur();

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-bf-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var actif = panel.getAttribute('data-bf-panel') === index;
          panel.classList.toggle('is-active', actif);
          // Un carrousel masque ne peut pas se mesurer : on le rafraichit
          // quand son onglet devient visible, et on met les autres en pause.
          var r = panel.querySelector('[data-bf-carousel]');
          if (!r) return;
          if (actif) { if (r._bfRefresh) r._bfRefresh(); }
          else if (r._bfPause) { r._bfPause(); }
        });
        placerIndicateur();
        // L'onglet choisi se remet dans le champ de vision sur mobile.
        if (barre && barre.scrollWidth > barre.clientWidth) {
          var cible = tab.offsetLeft - (barre.clientWidth - tab.offsetWidth) / 2;
          try { barre.scrollTo({ left: Math.max(0, cible), behavior: 'smooth' }); }
          catch (e) { barre.scrollLeft = Math.max(0, cible); }
        }
      });
    });
  }

  function initLookbook(root) {
    var stage = root.querySelector('[data-bf-lookbook]') || root;
    var medias = root.querySelectorAll('.bf-look-media');
    var details = root.querySelectorAll('.bf-look-detail');
    var dots = root.querySelectorAll('[data-bf-look-dot]');
    var prev = root.querySelector('[data-bf-look-prev]');
    var next = root.querySelector('[data-bf-look-next]');
    var count = Math.max(medias.length, details.length);
    if (!count) return;
    var current = 0;
    var autoplay = stage.getAttribute('data-autoplay') === 'true';
    var interval = (parseFloat(stage.getAttribute('data-interval')) || 5) * 1000;
    var timer = null;

    function show(index) {
      current = (index + count) % count;
      var key = String(current);
      medias.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-look') === key); });
      details.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-look') === key); });
      dots.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-bf-look-dot') === key); });
    }
    function start() { stop(); if (autoplay && count > 1) timer = setInterval(function () { show(current + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function go(index) { show(index); start(); } // nav manuelle : reinitialise le minuteur

    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-bf-look-dot'), 10)); });
    });

    // Swipe (mobile)
    if (count > 1) {
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 45) go(current + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }

    // Defilement automatique : pause au survol et quand l'onglet est masque
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  }

  // Les videos produit ne se lisent qu'au survol : inutile de les faire
  // tourner en fond sur toute la page.
  function initCardVideos(portee) {
    (portee || document).querySelectorAll('.bf-card').forEach(function (card) {
      if (card._bfVideoInit) return;
      card._bfVideoInit = true;
      var video = card.querySelector('.bf-card__video');
      if (!video) return;
      card.addEventListener('mouseenter', function () {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      });
      card.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  // Comparateur avant/apres : on deplace la ligne de rognage de la couche du
  // dessus. Les deux photos restent en pleine largeur, superposees.
  function initSplit(section) {
    var wrap = section.querySelector('[data-bf-split]');
    if (!wrap) return;
    var handle = wrap.querySelector('[data-bf-split-handle]');
    if (!handle) return;

    // Mobile : mise en page empilee (pas de slider) -> on n'attache pas le glisser.
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;

    var dragging = false;
    var position = parseFloat(wrap.getAttribute('data-start')) || 50;

    function setPosition(percent) {
      position = Math.max(2, Math.min(98, percent));
      wrap.style.setProperty('--bf-split-pos', position + '%');
      handle.setAttribute('aria-valuenow', Math.round(position));
    }

    function fromClientX(clientX) {
      var rect = wrap.getBoundingClientRect();
      if (!rect.width) return;
      setPosition(((clientX - rect.left) / rect.width) * 100);
    }

    // Le glisser demarre depuis n'importe quel point du cartouche, pas
    // seulement depuis la poignee.
    wrap.addEventListener('pointerdown', function (event) {
      if (event.target.closest('a')) return;
      dragging = true;
      wrap.setPointerCapture(event.pointerId);
      fromClientX(event.clientX);
      event.preventDefault();
    });
    wrap.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      fromClientX(event.clientX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      wrap.addEventListener(evt, function () { dragging = false; });
    });

    handle.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { setPosition(position - 4); event.preventDefault(); }
      if (event.key === 'ArrowRight') { setPosition(position + 4); event.preventDefault(); }
      if (event.key === 'Home') { setPosition(2); event.preventDefault(); }
      if (event.key === 'End') { setPosition(98); event.preventDefault(); }
    });

    setPosition(position);
  }

  // Hero slider : autoplay, fleches, points, swipe, pause au survol.
  function initHeroSlider(hero) {
    var slides = hero.querySelectorAll('[data-bf-slide]');
    if (slides.length < 2) return;
    var dots = hero.querySelectorAll('[data-bf-hero-dot]');
    var prev = hero.querySelector('[data-bf-hero-prev]');
    var next = hero.querySelector('[data-bf-hero-next]');
    var count = slides.length;
    var current = 0;
    var timer = null;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(i) {
      current = (i + count) % count;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
      // relance la video du slide actif depuis le debut
      slides.forEach(function (s, idx) {
        var v = s.querySelector('video');
        if (!v) return;
        if (idx === current) { try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function(){}); } catch (e) {} }
        else { v.pause(); }
      });
    }
    function go(n) { show(current + n); }
    function start() { if (autoplay && !reduce) { stop(); timer = setInterval(function () { go(1); }, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    if (next) next.addEventListener('click', function () { go(1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-bf-hero-dot'), 10)); start(); });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    // swipe tactile
    var sx = null;
    hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); start(); }
      sx = null;
    }, { passive: true });

    // pause quand l'onglet est masque
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    show(0);
    start();
  }

  // ===== Panier (AJAX + tiroir sur-mesure) =====
  var BFCART = { sectionId: 'bf-cart-drawer' };

  // Requete panier avec re-rendu serveur de la section tiroir (Section Rendering API).
  function cartPost(url, body) {
    body.sections = [BFCART.sectionId];
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'cart error');
        if (res.d.sections && res.d.sections[BFCART.sectionId]) swapCart(res.d.sections[BFCART.sectionId]);
        updateCartCount();
        return res.d;
      });
  }
  function cartAdd(items) { return cartPost('/cart/add.js', { items: items }); }
  function cartChange(body) { return cartPost('/cart/change.js', body); }

  // Remplace le contenu du tiroir en conservant l'element .bf-cartd (donc l'etat is-open).
  function swapCart(html) {
    var cur = document.querySelector('.bf-cartd');
    if (!cur) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var next = tmp.querySelector('.bf-cartd');
    if (!next) return;
    cur.innerHTML = next.innerHTML;
    loadReco();
    // Le pied du tiroir vient d'etre recree : la date estimee doit etre
    // recalculee, sinon elle resterait masquee.
    initEtaLivraison();
  }

  // Recharge la section a l'ouverture (reflete le vrai panier, ex. ajout depuis une fiche).
  function refreshCart() {
    fetch(window.location.pathname + '?section_id=' + BFCART.sectionId, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { swapCart(html); })
      .catch(function () { loadReco(); });
  }

  function openCart(doRefresh) {
    var el = document.querySelector('.bf-cartd'); if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', cartEsc);
    if (doRefresh === false) { loadReco(); } else { refreshCart(); }
  }
  function closeCart() {
    var el = document.querySelector('.bf-cartd'); if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', cartEsc);
  }
  function cartEsc(e) { if (e.key === 'Escape') closeCart(); }

  function changeLine(line, delta) {
    var key = line.getAttribute('data-key');
    var cur = parseInt((line.querySelector('.bf-cartd__qty-val') || {}).textContent, 10) || 1;
    var q = Math.max(0, cur + delta);
    line.classList.add('is-busy');
    cartChange({ id: key, quantity: q }).catch(function () { line.classList.remove('is-busy'); });
  }
  function removeLine(line) {
    line.classList.add('is-busy');
    cartChange({ id: line.getAttribute('data-key'), quantity: 0 }).catch(function () { line.classList.remove('is-busy'); });
  }
  function addReco(btn) {
    var id = btn.getAttribute('data-variant-id'); if (!id) return;
    var orig = btn.textContent; btn.classList.add('is-added'); btn.textContent = '✓';
    cartAdd([{ id: id, quantity: 1 }]).catch(function () { btn.classList.remove('is-added'); btn.textContent = orig; });
  }
  function toggleNote(btn) {
    var wrap = btn.closest('[data-bf-note]'); if (!wrap) return;
    var ta = wrap.querySelector('[data-bf-note-input]'); if (!ta) return;
    if (ta.hasAttribute('hidden')) { ta.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); ta.focus(); }
    else { ta.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
  }
  function saveNote(v) {
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: v }) });
  }

  // Prix (centimes) au format boutique : "€150,00".
  function bfMoney(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

  // L'ordre d'affichage du bloc "Completez avec", lu UNE fois dans la page
  // complete. L'API de rendu de section ne restitue pas les reglages du groupe
  // d'en-tete : le HTML qu'elle renvoie repasse data-order a "default", et le
  // tiroir s'en sert pour se reconstruire a chaque ouverture. Mesure faite sur
  // /?section_id=bf-cart-drawer, qui rend "default" quand la page rend "random".
  var BF_RECO_ORDRE = null;

  // "Completez avec" : recommandations Shopify (complementaires, repli sur associes).
  function loadReco() {
    var box = document.querySelector('[data-bf-reco]');
    var list = document.querySelector('[data-bf-reco-list]');
    if (!box || !list) return;
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 5;
    var addLabel = box.getAttribute('data-add-label') || 'Ajouter';
    var ordre = BF_RECO_ORDRE || box.getAttribute('data-order') || 'default';
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) { box.hidden = true; return; }
        var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = true; });
        var pid = cart.items[cart.items.length - 1].product_id;
        function fetchReco(intent) {
          return fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + (ordre === 'random' ? 10 : (limit + cart.items.length)) + '&intent=' + intent, { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (d) { return (d.products || []).filter(function (p) { return !inCart[p.id]; }); });
        }
        fetchReco('complementary')
          .then(function (prods) { return prods.length ? prods : fetchReco('related'); })
          .then(function (prods) {
            // La grille est a deux colonnes : on garde un nombre pair pour
            // ne jamais laisser une fiche seule sur la derniere ligne.
            var n = Math.max(2, limit - (limit % 2));
            if (ordre === 'random') {
              for (var i = prods.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var tmp = prods[i]; prods[i] = prods[j]; prods[j] = tmp;
              }
            }
            prods = prods.slice(0, n);
            if (!prods.length) { box.hidden = true; return; }
            renderReco(list, prods, addLabel);
            box.hidden = false;
          })
          .catch(function () { box.hidden = true; });
      })
      .catch(function () {});
  }
  // Le libelle affiche est le MODELE, comme sur toutes les fiches du site :
  // on coupe le titre au premier mot de couleur.
  var BF_COULEURS = ('noir,noire,camel,beige,sable,blanc,cass\u00e9,casse,gris,clair,fonc\u00e9,fonce,'
    + 'anthracite,marine,denim,naturel,marron,bordeaux,kaki,vert,taupe,argent,dor\u00e9,dore,dor\u00e9e,doree,'
    + 'rose,bleu,m\u00e9tal,metal,or,cognac,chocolat,cr\u00e8me,creme,ivoire,bronze,l\u00e9opard,leopard,'
    + 'multicolore,fuchsia,violet,jaune,orange,rouge,\u00e9cru,ecru,nude,prune,moutarde').split(',');
  function bfCategorie(titre) {
    var mots = String(titre || '').split(' ');
    var avant = [], dernier = '';
    for (var i = 0; i < mots.length; i++) {
      if (BF_COULEURS.indexOf(mots[i].toLowerCase()) !== -1) break;
      if (dernier) avant.push(dernier);
      dernier = mots[i];
    }
    return avant.join(' ');
  }
  function bfModele(titre) {
    var mots = String(titre || '').split(' ');
    var modele = '';
    for (var i = 0; i < mots.length; i++) {
      if (BF_COULEURS.indexOf(mots[i].toLowerCase()) !== -1) break;
      modele = mots[i];
    }
    return modele || titre;
  }

  function renderReco(list, prods, addLabel) {
    list.innerHTML = '';
    prods.forEach(function (p) {
      var v = null;
      (p.variants || []).some(function (x) { if (x.available) { v = x; return true; } return false; });
      if (!v) v = (p.variants || [])[0];
      if (!v) return;
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var imgSized = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
      var li = document.createElement('li'); li.className = 'bf-cartd__reco-item';
      // Pointures cliquables plutot qu'un bouton "Ajouter" qui ne dit pas
      // laquelle : c'est le fonctionnement des fiches du site.
      var tailles = (p.variants || []).filter(function (x) { return x.title; });
      var htmlTailles;
      if (tailles.length > 1) {
        htmlTailles = '<div class="bf-cartd__reco-sizes" data-bf-quickadd role="group" aria-label="Choisir une pointure">'
          + tailles.map(function (x) {
              return '<button type="button" class="bf-size' + (x.available ? '' : ' is-soldout') + '"'
                + (x.available ? ' data-variant-id="' + x.id + '"' : ' disabled aria-disabled="true"')
                + ' title="' + x.title + '">' + x.title + '</button>';
            }).join('')
          + '</div>';
      } else {
        htmlTailles = '<div class="bf-cartd__reco-sizes bf-cartd__reco-sizes--single" data-bf-quickadd>'
          + '<button type="button" class="bf-size bf-size--add" data-variant-id="' + v.id + '">'
          + addLabel + '</button></div>';
      }
      var cat = bfCategorie(p.title);
      li.innerHTML =
        '<a class="bf-cartd__reco-thumb" href="' + p.url + '" tabindex="-1" aria-hidden="true">'
          + (imgSized ? '<img src="' + imgSized + '" alt="" loading="lazy">' : '') + '</a>'
        + '<a class="bf-cartd__reco-row" href="' + p.url + '">'
          + '<span class="bf-cartd__reco-name">' + bfModele(p.title) + '</span>'
          + (cat ? '<span class="bf-cartd__reco-cat">' + cat + '</span>' : '')
          + '<span class="bf-cartd__reco-price">' + bfMoney(v.price) + '</span>'
        + '</a>'
        + htmlTailles;
      list.appendChild(li);
    });
    // Sur mobile la liste devient un carrousel a points, comme la section
    // "Nos best-sellers". Les points sont crees a cote de la liste.
    var dots = list.parentNode.querySelector('[data-bf-dots]');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'bf-rail-dots bf-cartd__reco-dots';
      dots.setAttribute('data-bf-dots', '');
      dots.setAttribute('role', 'tablist');
      dots.setAttribute('aria-label', 'Pages des suggestions');
      list.parentNode.appendChild(dots);
    }
    list.setAttribute('data-bf-carousel', '');
    list.setAttribute('data-bf-auto', '0');
    initRailCarousel(list);
    // Le tiroir s ouvre avec une transition : tant qu il est invisible, sa
    // largeur vaut zero et les points ne peuvent pas etre calcules. On
    // repasse une fois l ouverture terminee.
    setTimeout(function () { if (list._bfRefresh) list._bfRefresh(); }, 400);
    setTimeout(function () { if (list._bfRefresh) list._bfRefresh(); }, 900);
  }

  function initCartDrawer() {
    var el = document.querySelector('.bf-cartd'); if (!el) return;
    // Capture avant toute refonte du tiroir : ici, et seulement ici, le DOM
    // vient de la page complete et porte donc le vrai reglage.
    var boxInit = document.querySelector('[data-bf-reco]');
    if (boxInit && BF_RECO_ORDRE === null) {
      BF_RECO_ORDRE = boxInit.getAttribute('data-order') || 'default';
    }
    document.querySelectorAll('[data-bf-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-bf-cartd-close]')) { e.preventDefault(); closeCart(); return; }
      var line = t.closest('[data-bf-line]');
      if (line && t.closest('[data-bf-qty-inc]')) { changeLine(line, 1); return; }
      if (line && t.closest('[data-bf-qty-dec]')) { changeLine(line, -1); return; }
      if (line && t.closest('[data-bf-remove]')) { removeLine(line); return; }
      var recoAdd = t.closest('[data-bf-reco-add]'); if (recoAdd) { addReco(recoAdd); return; }
      var noteT = t.closest('[data-bf-note-toggle]'); if (noteT) { toggleNote(noteT); return; }
    });
    el.addEventListener('change', function (e) {
      if (e.target.matches('[data-bf-note-input]')) saveNote(e.target.value);
    });
  }

  // ===== Recherche plein ecran (predictive, grille de cartes) =====
  function initSearch() {
    var box = document.querySelector('[data-bf-search]'); if (!box) return;
    var input = box.querySelector('[data-bf-search-input]');
    var suggest = box.querySelector('[data-bf-search-suggest]');
    var results = box.querySelector('[data-bf-search-results]');
    var form = box.querySelector('.bf-search__form');
    var timer, lastQ = '';

    function open() {
      box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', esc);
      setTimeout(function () { if (input) input.focus(); }, 90);
    }
    function close() {
      box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', esc);
    }
    function esc(e) { if (e.key === 'Escape') close(); }

    document.querySelectorAll('[data-bf-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    box.querySelectorAll('[data-bf-search-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });

    function showSuggest() { if (suggest) suggest.hidden = false; if (results) results.hidden = true; box.classList.remove('is-loading'); }
    function showResults() { if (suggest) suggest.hidden = true; if (results) results.hidden = false; }

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { showSuggest(); lastQ = ''; return; }
        if (q === lastQ) return;
        box.classList.add('is-loading');
        timer = setTimeout(function () { predict(q); }, 200);
      });
    }

    // URL de recherche predictive. On ajoute variants.sku / variants.barcode aux champs
    // cherches (Shopify ne cherche PAS le SKU par defaut) tout en gardant les champs standards.
    function suggestUrl(q) {
      return '/search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,variants.barcode,tag' +
        '&section_id=bf-search-results';
    }

    function predict(q) {
      lastQ = q;
      fetch(suggestUrl(q), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (input.value.trim() !== q) return; // resultat perime
          injectResults(html);
        })
        .catch(function () { box.classList.remove('is-loading'); });
    }

    // Injecte la section rendue par Shopify (memes cartes que "Nos best-sellers").
    function injectResults(html) {
      box.classList.remove('is-loading');
      showResults();
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var content = tmp.querySelector('.bf-home') || tmp;
      results.innerHTML = content.innerHTML;
    }

    // Cherche une carte dont un SKU correspond a la saisie (exact prioritaire, sinon prefixe).
    function findSkuUrl(root, q) {
      var qn = q.toLowerCase().trim();
      var cells = root.querySelectorAll('[data-skus]');
      var prefixUrl = null;
      for (var i = 0; i < cells.length; i++) {
        var skus = (cells[i].getAttribute('data-skus') || '').split(/\s+/);
        for (var j = 0; j < skus.length; j++) {
          if (!skus[j]) continue;
          if (skus[j] === qn) return cells[i].getAttribute('data-url');
          if (prefixUrl === null && skus[j].indexOf(qn) === 0) prefixUrl = cells[i].getAttribute('data-url');
        }
      }
      return prefixUrl;
    }

    // Touche Entree : si la saisie est une reference (SKU), aller direct sur le produit ;
    // sinon recherche classique (page /search).
    if (form) {
      form.addEventListener('submit', function (e) {
        var q = input.value.trim();
        if (!q) { e.preventDefault(); return; }
        var direct = findSkuUrl(results, q);
        if (direct) { e.preventDefault(); window.location.href = direct; return; }
        if (!/\d/.test(q)) return; // mot-cle sans chiffre -> recherche classique
        e.preventDefault(); // reference potentielle : on resout avant de rediriger
        fetch(suggestUrl(q), { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            var url = findSkuUrl(tmp, q);
            if (!url) { var c = tmp.querySelector('[data-url]'); if (c) url = c.getAttribute('data-url'); }
            window.location.href = url || ('/search?q=' + encodeURIComponent(q) + '&type=product');
          })
          .catch(function () { window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product'; });
      });
    }
  }

  // ===== Selecteur de langue =====
  function initLang() {
    var wrap = document.querySelector('[data-bf-lang]'); if (!wrap) return;
    var btn = wrap.querySelector('[data-bf-lang-toggle]');
    var menu = wrap.querySelector('[data-bf-lang-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hasAttribute('hidden')) { menu.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
      else { menu.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) { menu.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
    });
  }

  // Achat rapide : clic sur une taille -> ajout au panier (AJAX) + ouverture du tiroir.
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.bf-size[data-variant-id]');
      if (!btn || !btn.closest('[data-bf-quickadd]')) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      var id = btn.getAttribute('data-variant-id');
      var original = btn.textContent;
      btn.classList.add('is-loading');
      cartAdd([{ id: id, quantity: 1 }])
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = '✓';
          openCart(false);
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = original; }, 1400);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.textContent = '!';
          setTimeout(function () { btn.textContent = original; }, 1400);
        });
    });
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var cartLink = document.querySelector('.bf-utility a[aria-label^="Panier"]');
        if (cartLink && !cartLink.querySelector('.bf-cart-count') && count > 0) {
          var b = document.createElement('span'); b.className = 'bf-cart-count'; cartLink.appendChild(b);
        }
        document.querySelectorAll('.bf-cart-count').forEach(function (el) {
          el.textContent = count; el.style.display = count > 0 ? '' : 'none';
        });
        document.dispatchEvent(new CustomEvent('bf:cart:updated', { detail: cart }));
      });
  }

  // Fenetre Apercu rapide : ouvre une popup avec le produit (image, titre, prix,
  // tailles, ajout au panier) sans aller sur la fiche. Donnees via /products/{h}.js
  var BFQV = { root:null, product:null, variant:null, qty:1, caract:'', money:function(c){return (c/100).toLocaleString('fr-FR',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'});} };

  function bfqvEl(sel){ return BFQV.root.querySelector(sel); }

  function openQuickView(handle, caract) {
    BFQV.root = document.querySelector('[data-bf-qv]');
    if (!BFQV.root) return;
    BFQV.caract = caract || '';
    BFQV.qty = 1;
    var qv0 = BFQV.root.querySelector('[data-bf-qv-qtyval]'); if (qv0) qv0.textContent = '1';
    showQV();
    setQVLoading(true);
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) { BFQV.product = product; renderQV(product); })
      .catch(function () { setQVLoading(false); });
  }

  function setQVLoading(on){ if(BFQV.root) BFQV.root.classList.toggle('is-loading', on); }

  function showQV(){
    BFQV.root.hidden = false; BFQV.root.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', qvEsc);
  }
  function closeQV(){
    if(!BFQV.root) return;
    BFQV.root.hidden = true; BFQV.root.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', qvEsc);
  }
  function qvEsc(e){ if(e.key==='Escape') closeQV(); }

  function renderQV(p){
    setQVLoading(false);
    var img = bfqvEl('[data-bf-qv-image]');
    function sized(u, w){ if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; return u.replace(/(\.[a-z]+)(\?|$)/i, '_'+w+'x$1$2'); }
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    img.src = sized(imgs[0], 900); img.alt = p.title;
    // galerie : vignettes des autres vues
    var thumbs = bfqvEl('[data-bf-qv-thumbs]'); thumbs.innerHTML = '';
    if (imgs.length > 1) {
      imgs.slice(0, 6).forEach(function(u, idx){
        var t = document.createElement('button');
        t.type='button'; t.className='bf-qv__thumb'+(idx===0?' is-active':'');
        var ti = document.createElement('img'); ti.src = sized(u, 160); ti.alt=''; ti.loading='lazy';
        t.appendChild(ti);
        t.addEventListener('click', function(){
          img.src = sized(u, 900);
          thumbs.querySelectorAll('.bf-qv__thumb').forEach(function(x){x.classList.remove('is-active');});
          t.classList.add('is-active');
        });
        thumbs.appendChild(t);
      });
      thumbs.style.display = '';
    } else { thumbs.style.display = 'none'; }
    var titleEl = bfqvEl('[data-bf-qv-title]'); titleEl.textContent = p.title; titleEl.href = '/products/'+p.handle;
    bfqvEl('[data-bf-qv-more]').href = '/products/'+p.handle;
    bfqvEl('[data-bf-qv-price]').textContent = BFQV.money(p.price);
    var desc = bfqvEl('[data-bf-qv-desc]');
    var tmp = document.createElement('div'); tmp.innerHTML = p.description || '';
    desc.textContent = (tmp.textContent||'').trim().slice(0,180);

    // Caracteristiques produit (metachamps) transmises par le bouton
    var specs = bfqvEl('[data-bf-qv-specs]'); specs.innerHTML = '';
    if (BFQV.caract) {
      BFQV.caract.split(';;').forEach(function(pair){
        if (!pair) return;
        var kv = pair.split('|'); if (kv.length < 2) return;
        var row = document.createElement('div'); row.className = 'bf-qv__spec';
        var dt = document.createElement('span'); dt.className='bf-qv__spec-k'; dt.textContent = kv[0];
        var dd = document.createElement('span'); dd.className='bf-qv__spec-v'; dd.textContent = kv[1];
        row.appendChild(dt); row.appendChild(dd); specs.appendChild(row);
      });
    }

    var hasSizes = p.variants.length > 1;
    bfqvEl('[data-bf-qv-sizelabel]').hidden = !hasSizes;
    var wrap = bfqvEl('[data-bf-qv-sizes]'); wrap.innerHTML = '';
    BFQV.variant = null;
    var addBtn = bfqvEl('[data-bf-qv-add]');
    var addTxt = bfqvEl('[data-bf-qv-addtext]');
    bfqvEl('[data-bf-qv-feedback]').hidden = true;
    var eye = bfqvEl('[data-bf-qv-eyebrow]');
    if (p.type) { eye.textContent = p.type; eye.hidden = false; } else { eye.hidden = true; }

    if (hasSizes) {
      p.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type='button'; b.className='bf-qv-size'+(v.available?'':' is-soldout');
        b.textContent = v.title;
        if (!v.available) { b.disabled = true; }
        b.addEventListener('click', function () {
          wrap.querySelectorAll('.bf-qv-size').forEach(function(x){x.classList.remove('is-selected');});
          b.classList.add('is-selected');
          BFQV.variant = v;
          addBtn.disabled = false; addTxt.textContent = 'Ajouter au panier';
        });
        wrap.appendChild(b);
      });
      addBtn.disabled = true; addTxt.textContent = 'Choisissez votre pointure';
    } else {
      BFQV.variant = p.variants[0];
      addBtn.disabled = !p.available; addTxt.textContent = p.available ? 'Ajouter au panier' : 'Épuisé';
    }
  }

  function qvAdd(){
    var addBtn = bfqvEl('[data-bf-qv-add]');
    var addTxt = bfqvEl('[data-bf-qv-addtext]');
    if (!BFQV.variant || addBtn.disabled) return;
    addBtn.disabled = true; addTxt.textContent = 'Ajout…';
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: BFQV.variant.id, quantity: BFQV.qty }] })
    }).then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
      .then(function(res){
        if(!res.ok) throw new Error();
        updateCartCount();
        var fb = bfqvEl('[data-bf-qv-feedback]'); fb.hidden=false; fb.textContent='Ajouté au panier ✓';
        addTxt.textContent = 'Ajouté ✓';
        setTimeout(function(){ addBtn.disabled=false; addTxt.textContent='Ajouter au panier'; }, 1400);
      }).catch(function(){ addBtn.disabled=false; addTxt.textContent='Réessayer'; });
  }

  function initQuickView(){
    var root = document.querySelector('[data-bf-qv]');
    if (!root) return;
    root.querySelectorAll('[data-bf-qv-close]').forEach(function(el){ el.addEventListener('click', closeQV); });
    root.querySelector('[data-bf-qv-add]').addEventListener('click', qvAdd);
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-bf-quickview]'); if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      openQuickView(btn.getAttribute('data-bf-quickview'), btn.getAttribute('data-caract') || '');
    });
    // quantite
    var qroot = document.querySelector('[data-bf-qv]');
    if (qroot) {
      var minus = qroot.querySelector('[data-bf-qv-minus]'), plus = qroot.querySelector('[data-bf-qv-plus]'), val = qroot.querySelector('[data-bf-qv-qtyval]');
      if (minus) minus.addEventListener('click', function(){ BFQV.qty = Math.max(1, BFQV.qty-1); val.textContent = BFQV.qty; });
      if (plus) plus.addEventListener('click', function(){ BFQV.qty = Math.min(10, BFQV.qty+1); val.textContent = BFQV.qty; });
    }
  }

  // Ordre aleatoire : melange les cartes des rails marques data-bf-random.
  function initRandomRails(racine) {
    (racine || document).querySelectorAll('.bf-rail[data-bf-random]').forEach(function (rail) {
      var cards = Array.prototype.slice.call(rail.children);
      for (var i = cards.length - 1; i > 0; i--) {
        var jdx = Math.floor(Math.random() * (i + 1));
        rail.insertBefore(cards[jdx], cards[i].nextSibling);
        cards = Array.prototype.slice.call(rail.children);
      }
      // Le rail recoit un pool plus large que l'affichage voulu : on coupe
      // APRES melange, sinon on ne ferait que reordonner les memes produits.
      var garder = parseInt(rail.getAttribute('data-bf-random-garder'), 10) || 0;
      if (garder > 0) {
        Array.prototype.slice.call(rail.children).slice(garder).forEach(function (c) {
          if (c.parentNode) c.parentNode.removeChild(c);
        });
      }
    });
  }

  // Ordre aleatoire dans le mega-menu : ne melange QUE les cartes produit,
  // les visuels promo gardent leur place.
  function initRandomMegaCards() {
    document.querySelectorAll('[data-bf-random-cards]').forEach(function (box) {
      var cards = Array.prototype.slice.call(box.querySelectorAll('.bf-card'));
      if (cards.length < 2) return;
      var anchor = cards[0].previousElementSibling; // dernier element (promo) avant les cartes, ou null
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
      }
      cards.forEach(function (card) {
        if (anchor && anchor.parentNode === box) {
          box.insertBefore(card, anchor.nextSibling);
          anchor = card;
        } else {
          box.appendChild(card);
          anchor = card;
        }
      });
      // Le panneau rend un pool plus large que le nombre demande dans
      // l'editeur : on retire l'excedent une fois le melange fait.
      var garder = parseInt(box.getAttribute('data-bf-random-cards'), 10) || 0;
      if (garder > 0) {
        cards.slice(garder).forEach(function (c) {
          if (c.parentNode) c.parentNode.removeChild(c);
        });
      }
    });
  }

  // Fiche produit : selection de taille, ajout au panier (via cartAdd + openCart), lire la suite, guide des tailles.
  function initProduct() {
    var root = document.querySelector('[data-bf-pdp]');
    if (!root) return;

    // La fiche porte deux jeux de pointures et deux boutons d'ajout : celui
    // de la page et celui de la barre collee en bas. Une seule logique, les
    // deux jeux sont tenus synchronises. La barre vit hors de la <section>,
    // d'ou la portee elargie au bloc .bf-home.
    var scope = root.closest ? (root.closest('.bf-home') || document) : document;
    var addBtns = [].slice.call(scope.querySelectorAll('[data-bf-pdp-add]'));
    var addTxts = [].slice.call(scope.querySelectorAll('[data-bf-pdp-addtext]'));
    var sizesWraps = [].slice.call(scope.querySelectorAll('[data-bf-pdp-sizes]'));
    var selected = null;

    // ---- Compteur de stock, par pointure ----
    // La quantite vient du bouton lui-meme. Liquid ne pose l'attribut que si
    // Shopify suit le stock ET n'autorise pas la survente : pas d'attribut,
    // on se tait. Mieux vaut ne rien dire qu'annoncer un chiffre faux.
    var stockEl = scope.querySelector('[data-bf-pdp-stock]');
    var stockTxt = stockEl && stockEl.querySelector('[data-bf-pdp-stock-text]');
    var stockFill = stockEl && stockEl.querySelector('[data-bf-pdp-stock-fill]');
    function majStock(btn) {
      if (!stockEl) return;
      var brut = btn ? btn.getAttribute('data-variant-stock') : null;
      var n = (brut === null || brut === '') ? NaN : parseInt(brut, 10);
      var seuil = parseInt(stockEl.getAttribute('data-seuil'), 10) || 5;
      var base = parseInt(stockEl.getAttribute('data-base'), 10) || 15;
      var seulementFaible = stockEl.getAttribute('data-seulement-faible') === '1';
      if (isNaN(n) || n <= 0 || (seulementFaible && n > seuil)) { stockEl.hidden = true; return; }
      var modele = (n === 1)
        ? (stockEl.getAttribute('data-texte-un') || 'Derniere piece disponible')
        : (stockEl.getAttribute('data-texte') || 'Plus que {n} en stock');
      if (stockTxt) stockTxt.textContent = modele.replace('{n}', String(n));
      if (stockFill) stockFill.style.width = Math.max(4, Math.min(100, Math.round(n / base * 100))) + '%';
      stockEl.classList.toggle('is-low', n <= seuil);
      stockEl.hidden = false;
    }

    function texte(t) { addTxts.forEach(function (x) { x.textContent = t; }); }
    function bloquer(v) { addBtns.forEach(function (b) { b.disabled = v; }); }

    sizesWraps.forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('.bf-pdp__size');
        if (!b || b.disabled || b.classList.contains('is-soldout')) return;
        selected = b.getAttribute('data-variant-id');
        sizesWraps.forEach(function (w) {
          w.querySelectorAll('.bf-pdp__size').forEach(function (x) {
            x.classList.toggle('is-selected', x.getAttribute('data-variant-id') === selected);
          });
        });
        bloquer(false);
        texte('Ajouter au panier');
        majStock(b);
      });
    });

    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        // Articles a ajouter. Priorite au widget de paliers (bf-bundle) :
        //  - data-bf-bundle-items = liste d'ids (une pointure par paire) -> chaque x1.
        //  - sinon data-active-qty (meme pointure x N) avec la pointure choisie.
        // Sans widget : la pointure choisie x 1.
        var items = null;
        var bundleEl = document.querySelector('[data-bf-bundle]');
        if (bundleEl) {
          var raw = bundleEl.getAttribute('data-bf-bundle-items') || '';
          var ids = raw.split(',').filter(function (x) { return x; });
          if (ids.length) {
            items = ids.map(function (id) { return { id: id, quantity: 1 }; });
          } else if (selected) {
            var q = parseInt(bundleEl.getAttribute('data-active-qty'), 10) || 1;
            items = [{ id: selected, quantity: q }];
          }
        } else if (selected) {
          items = [{ id: selected, quantity: 1 }];
        }
        if (!items) return;
        // Options / personnalisation : bloque si un champ requis est vide,
        // sinon joint les valeurs comme proprietes de ligne.
        var oc = bfCollectOptions();
        if (oc.missing) {
          oc.missing.classList.add('bf-opt--error');
          oc.missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var fld = oc.missing.querySelector('[data-bf-opt-input] input, [data-bf-opt-input]');
          if (fld && fld.focus) { try { fld.focus(); } catch (e) {} }
          texte('Complétez les options');
          setTimeout(function () { texte('Ajouter au panier'); }, 1800);
          return;
        }
        if (oc.props && Object.keys(oc.props).length) {
          items = items.map(function (it) { it.properties = oc.props; return it; });
        }
        // Options PAYANTES : chaque add-on coche = un produit ajoute au panier.
        var bfAddons = bfCollectAddons();
        bfAddons.forEach(function (a) { if (a.id) items.push({ id: a.id, quantity: 1 }); });
        var bfFiles = bfCollectFiles();
        bloquer(true);
        texte('Ajout…');
        var onOk = function () {
          texte('Ajouté ✓'); openCart(true);
          setTimeout(function () { bloquer(false); texte('Ajouter au panier'); }, 1500);
        };
        var onErr = function () {
          bloquer(false); texte('Réessayer');
          setTimeout(function () { texte('Ajouter au panier'); }, 1600);
        };
        if (bfFiles.length) {
          // Un fichier ne passe pas en JSON : envoi du 1er article en FormData
          // (id + quantite + proprietes texte + fichiers), puis le reste en JSON.
          var main = items[0];
          var fd = new FormData();
          fd.append('id', main.id);
          fd.append('quantity', main.quantity || 1);
          if (oc.props) { for (var k in oc.props) { if (oc.props.hasOwnProperty(k)) fd.append('properties[' + k + ']', oc.props[k]); } }
          bfFiles.forEach(function (f) { fd.append('properties[' + f.name + ']', f.file); });
          fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
            .then(function () { var rest = items.slice(1); return rest.length ? cartAdd(rest) : null; })
            .then(onOk).catch(onErr);
        } else {
          cartAdd(items).then(onOk).catch(onErr);
        }
      });
    });

    // La barre monte quand le bloc d'achat de la page est passe : avant, elle
    // ferait doublon avec le bouton deja visible.
    // Repere : les images du produit. La barre monte des qu'elles ont quitte
    // l'ecran, pas plus tard : c'est a ce moment que le client perd le produit
    // de vue et a besoin du prix, des pointures et du bouton.
    var barre = scope.querySelector('[data-bf-pdp-bar]');
    var ancre = root.querySelector('.bf-pdp__media') || root.querySelector('.bf-pdp__add:not(.bf-pdp__add--bar)');
    if (barre && ancre) {
      var majBarre = function () {
        var visible = ancre.getBoundingClientRect().bottom > 0;
        barre.classList.toggle('is-on', !visible);
        // La barre recouvre le bas de page : on lui reserve la place.
        document.body.classList.toggle('bf-bar-on', !visible);
      };
      window.addEventListener('scroll', majBarre, { passive: true });
      window.addEventListener('resize', majBarre);
      majBarre();
    }

    var desc = root.querySelector('[data-bf-pdp-desc]');
    if (desc) {
      var rm = desc.querySelector('[data-bf-pdp-readmore]');
      var txt = desc.querySelector('.bf-pdp__desc-text');
      if (txt && rm && txt.scrollHeight <= txt.clientHeight + 2) { rm.style.display = 'none'; }
      if (rm) rm.addEventListener('click', function () {
        var isOpen = desc.classList.toggle('is-open');
        rm.textContent = isOpen ? 'Réduire' : 'Lire la suite';
      });
    }

    var sg = root.querySelector('[data-bf-pdp-sizeguide]');
    if (sg) sg.addEventListener('click', function () {
      var target = root.querySelector('[data-bf-sizeguide-target]');
      if (!target) return;
      // Sur mobile, le guide des tailles s'ouvre dans la meme fenetre que les
      // autres sections : c'est le contenu le plus long de la fiche, celui
      // qu'on perdait le plus a deplier en place.
      var modale = document.querySelector('[data-bf-accm]');
      if (modale && modale._bfEnFenetre && modale._bfEnFenetre()) {
        modale._bfOuvrir(target);
        return;
      }
      target.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // Options / personnalisation produit (bf-options). Valeur -> line item property.
  function bfOptionValue(el) {
    var type = el.getAttribute('data-opt-type');
    if (type === 'radio') { var r = el.querySelector('input[type=radio]:checked'); return r ? r.value : ''; }
    if (type === 'checkbox') {
      return [].slice.call(el.querySelectorAll('input[type=checkbox]:checked')).map(function (c) { return c.value; }).join(', ');
    }
    if (type === 'swatch') { var s = el.querySelector('.bf-opt__swatch.is-active'); return s ? s.getAttribute('data-value') : ''; }
    if (type === 'file') { var f = el.querySelector('[data-bf-opt-file]'); return (f && f.files && f.files.length) ? f.files[0].name : ''; }
    var inp = el.querySelector('[data-bf-opt-input]');
    return (inp && inp.value != null) ? inp.value : '';
  }
  // Retourne { props: {nom:valeur}, missing: element requis vide|null }.
  function bfCollectOptions() {
    var wrap = document.querySelector('[data-bf-opts]');
    if (!wrap) return { props: null, missing: null };
    var props = {}, missing = null;
    [].forEach.call(wrap.querySelectorAll('[data-bf-opt]'), function (el) {
      if (el.hidden) return; // masqué par une condition -> ignoré
      var type = el.getAttribute('data-opt-type');
      if (type === 'heading' || type === 'paragraph' || type === 'divider') return;
      var name = el.getAttribute('data-opt-name') || 'Option';
      var v = ('' + bfOptionValue(el)).trim();
      if (el.getAttribute('data-opt-required') === '1' && !v && !missing) missing = el;
      // Les fichiers ne passent pas en JSON : ils sont envoyes a part (FormData).
      if (v && type !== 'file') props[name] = v;
    });
    return { props: props, missing: missing };
  }
  // Fichiers choisis (option type « file »), hors champs masques par une condition.
  function bfCollectFiles() {
    var wrap = document.querySelector('[data-bf-opts]');
    if (!wrap) return [];
    var out = [];
    [].forEach.call(wrap.querySelectorAll('[data-bf-opt-file]'), function (f) {
      var host = f.closest('[data-bf-opt]');
      if (host && host.hidden) return;
      if (f.files && f.files.length) out.push({ name: host.getAttribute('data-opt-name') || 'Fichier', file: f.files[0] });
    });
    return out;
  }
  function bfMoneyFmt(cents) {
    var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: c }); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + c; }
  }
  // Options PAYANTES : add-on coches (produits ajoutes au panier). Ignore si masque par une condition.
  function bfCollectAddons() {
    var wrap = document.querySelector('[data-bf-opts]');
    if (!wrap) return [];
    var out = [];
    [].forEach.call(wrap.querySelectorAll('[data-bf-opt-addon]'), function (cb) {
      var host = cb.closest('[data-bf-opt]');
      if (host && host.hidden) return;
      if (cb.checked && !cb.disabled) {
        out.push({ id: cb.getAttribute('data-addon-id'), price: parseInt(cb.getAttribute('data-addon-price'), 10) || 0 });
      }
    });
    return out;
  }
  function bfUpdateAddonTotal() {
    var el = document.querySelector('[data-bf-opts-total]');
    if (!el) return;
    var sum = bfCollectAddons().reduce(function (t, a) { return t + a.price; }, 0);
    if (sum > 0) { el.textContent = (el.getAttribute('data-label') || 'Options') + ' : +' + bfMoneyFmt(sum); el.hidden = false; }
    else { el.hidden = true; }
  }

  function initOptions() {
    var wrap = document.querySelector('[data-bf-opts]');
    if (!wrap || wrap._bfOptInit) return;
    wrap._bfOptInit = true;
    var opts = [].slice.call(wrap.querySelectorAll('[data-bf-opt]'));
    function applyConditions() {
      opts.forEach(function (el) {
        var cf = el.getAttribute('data-opt-cond-field');
        if (!cf) return;
        var cv = el.getAttribute('data-opt-cond-value');
        var src = null;
        for (var i = 0; i < opts.length; i++) { if (opts[i].getAttribute('data-opt-name') === cf) { src = opts[i]; break; } }
        var match = src ? (('' + bfOptionValue(src)).trim() === cv) : false;
        el.hidden = !match;
      });
    }
    wrap.addEventListener('click', function (e) {
      var sw = e.target.closest('.bf-opt__swatch');
      if (!sw) return;
      var grp = sw.parentElement;
      grp.querySelectorAll('.bf-opt__swatch').forEach(function (x) { x.classList.toggle('is-active', x === sw); });
      var host = sw.closest('[data-bf-opt]'); if (host) host.classList.remove('bf-opt--error');
      applyConditions();
    });
    wrap.addEventListener('change', function () { applyConditions(); bfUpdateAddonTotal(); });
    wrap.addEventListener('input', function (e) {
      var host = e.target.closest('[data-bf-opt]'); if (host) host.classList.remove('bf-opt--error');
      applyConditions();
    });
    applyConditions();
    bfUpdateAddonTotal();
  }

  // Widget "Paliers de quantite" (bf-bundle), rendu dans la fiche sous le bouton
  // d'achat. Selection du palier, menus "une pointure par paire", pilotage de
  // l'ajout au panier (via les attributs lus par initProduct).
  function initBundle() {
    var roots = [].slice.call(document.querySelectorAll('[data-bf-bundle]'));
    if (!roots.length) return;

    function money(cents) {
      var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: c }); }
      catch (e) { return (cents / 100).toFixed(2) + ' ' + c; }
    }
    function variantsOf(root) {
      var s = root.querySelector('[data-bf-bundle-variants]');
      if (!s) return [];
      try { return JSON.parse(s.textContent); } catch (e) { return []; }
    }
    function activeTier(root) { return root.querySelector('[data-bf-bundle-tier].is-active'); }
    // Bloc "Tailles" de la fiche (page, pas la barre collee).
    function pageSizeBlock() {
      var sz = document.querySelector('.bf-pdp__sizes:not(.bf-pdp__sizes--bar)');
      return sz ? (sz.closest('.bf-pdp__block') || sz) : null;
    }
    function setAdd(on, text) {
      [].forEach.call(document.querySelectorAll('[data-bf-pdp-add]'), function (b) { b.disabled = !on; });
      if (text) { [].forEach.call(document.querySelectorAll('[data-bf-pdp-addtext]'), function (x) { x.textContent = text; }); }
    }
    function computeTier(tier, base) {
      var q = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var dtype = tier.getAttribute('data-dtype') || 'none';
      var dval = parseFloat(tier.getAttribute('data-dvalue')) || 0;
      var full = base * q, total = full;
      if (dtype === 'percent' && dval > 0) total = Math.round(full * (100 - dval) / 100);
      else if (dtype === 'amount' && dval > 0) total = full - Math.round(dval * 100);
      if (total < 0) total = 0;
      return { q: q, full: full, total: total, saving: full - total, unit: Math.round(total / q) };
    }
    function refreshPrices(root) {
      var base = parseInt(root.getAttribute('data-base-cents'), 10) || 0;
      if (!base) return;
      var perTpl = root.getAttribute('data-perunit-text') || '[value] /unité';
      var saveTpl = root.getAttribute('data-save-text') || 'Économisez [value]';
      [].forEach.call(root.querySelectorAll('[data-bf-bundle-tier]'), function (tier) {
        var r = computeTier(tier, base);
        var t = tier.querySelector('[data-bf-bundle-total]');
        var c = tier.querySelector('[data-bf-bundle-cmp]');
        var u = tier.querySelector('[data-bf-bundle-unit]');
        var s = tier.querySelector('[data-bf-bundle-savewrap]');
        if (t) t.textContent = money(r.total);
        if (c) c.textContent = money(r.full);
        if (u) u.textContent = perTpl.replace('[value]', money(r.unit));
        if (s) s.textContent = saveTpl.replace('[value]', money(r.saving));
      });
    }
    function syncItems(root) {
      var ids = [].map.call(root.querySelectorAll('[data-bf-bundle-pick]'), function (s) { return s.value; })
        .filter(function (x) { return x; });
      if (ids.length) root.setAttribute('data-bf-bundle-items', ids.join(','));
      else root.removeAttribute('data-bf-bundle-items');
    }
    function buildPicks(root) {
      var perUnit = root.getAttribute('data-variant-per-unit') === '1';
      var picks = root.querySelector('[data-bf-bundle-picks]');
      var tier = activeTier(root);
      var block = pageSizeBlock();
      if (!tier) return;
      var q = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      root.setAttribute('data-active-qty', String(q));
      var variants = variantsOf(root);
      var avail = variants.filter(function (v) { return v.available; });

      if (perUnit && q >= 2 && picks && variants.length) {
        var pairTpl = root.getAttribute('data-pair-label') || 'Paire [n]';
        var html = '';
        for (var i = 0; i < q; i++) {
          var def = avail.length ? avail[Math.min(i, avail.length - 1)].id : (variants[0] && variants[0].id);
          html += '<label class="bf-bundle__pick"><span class="bf-bundle__pick-lab">'
            + pairTpl.replace('[n]', (i + 1)) + '</span><select data-bf-bundle-pick>';
          variants.forEach(function (v) {
            html += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled')
              + (v.id === def ? ' selected' : '') + '>' + v.title + (v.available ? '' : ' — épuisé') + '</option>';
          });
          html += '</select></label>';
        }
        picks.innerHTML = html;
        picks.hidden = false;
        if (block) block.hidden = true;
        syncItems(root);
        setAdd(true, 'Ajouter au panier');
      } else {
        if (picks) { picks.innerHTML = ''; picks.hidden = true; }
        if (block) block.hidden = false;
        root.removeAttribute('data-bf-bundle-items');
        // Retour au fonctionnement de la fiche : le bouton s'active a la pointure.
        var chosen = document.querySelector('.bf-pdp__size.is-selected');
        setAdd(!!chosen, chosen ? 'Ajouter au panier' : null);
      }
    }
    function selectTier(root, tier) {
      [].forEach.call(root.querySelectorAll('[data-bf-bundle-tier]'), function (t) {
        var on = t === tier;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      buildPicks(root);
    }

    // ---- Compte a rebours (urgence) ----
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function initCountdown(el) {
      if (!el || el._bfCdInit) return;
      el._bfCdInit = true;
      var clock = el.querySelector('[data-bf-bundle-cd-clock]');
      if (!clock) return;
      var mode = el.getAttribute('data-mode') || 'evergreen';
      var units = el.getAttribute('data-units') === '1';
      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 720;
      var lib = { d: 'J', h: 'H', m: 'M', s: 'S' };
      var lsKey = 'bfBundleCd:' + (location.pathname || '') + ':' + mins;

      function target() {
        if (mode === 'fixed') {
          var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
          var t = Date.parse(raw);
          return isNaN(t) ? 0 : t;
        }
        // evergreen : redemarre par visiteur a chaque cycle
        var now = Date.now(), end = 0;
        try { end = parseInt(localStorage.getItem(lsKey), 10) || 0; } catch (e) {}
        if (!end || end < now) {
          end = now + mins * 60000;
          try { localStorage.setItem(lsKey, String(end)); } catch (e) {}
        }
        return end;
      }
      function box(v, u) {
        return '<span class="bf-bundle__cd-box"><b>' + pad(v) + '</b>'
          + (units ? '<i>' + u + '</i>' : '') + '</span>';
      }
      function tick() {
        var t = target();
        if (!t) { el.hidden = true; return; }
        var rem = t - Date.now();
        if (rem <= 0) {
          if (mode === 'fixed') { el.hidden = true; clearInterval(el._bfCdTimer); return; }
          try { localStorage.removeItem(lsKey); } catch (e) {}
          rem = mins * 60000; // relance immediate
        }
        var s = Math.floor(rem / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var html = (d > 0 ? box(d, lib.d) : '') + box(h, lib.h) + box(m, lib.m) + box(s, lib.s);
        clock.innerHTML = html;
        el.hidden = false;
      }
      tick();
      el._bfCdTimer = setInterval(tick, 1000);
    }

    roots.forEach(function (root) {
      if (root._bfBundleInit) return;
      root._bfBundleInit = true;
      root.addEventListener('click', function (e) {
        var tier = e.target.closest('[data-bf-bundle-tier]');
        if (tier && root.contains(tier)) selectTier(root, tier);
      });
      root.addEventListener('change', function (e) {
        if (e.target.closest('[data-bf-bundle-pick]')) syncItems(root);
      });
      // Le prix suit la pointure choisie (packs "meme pointure" / palier 1).
      document.addEventListener('click', function (e) {
        var size = e.target.closest('.bf-pdp__size[data-variant-price-cents]');
        if (!size) return;
        var cents = parseInt(size.getAttribute('data-variant-price-cents'), 10);
        if (cents) { root.setAttribute('data-base-cents', String(cents)); refreshPrices(root); }
      }, true);

      if (!activeTier(root)) {
        var first = root.querySelector('[data-bf-bundle-tier]');
        if (first) { first.classList.add('is-active'); first.setAttribute('aria-pressed', 'true'); }
      }
      refreshPrices(root);
      buildPicks(root);
      initCountdown(root.querySelector('[data-bf-bundle-cd]'));
    });
  }

  // Carrousel "Familles" (mobile) : dots, defilement auto, pause a l'interaction.
  function initCatCarousel(root) {
    var rail = root.querySelector('[data-bf-cat-rail]');
    if (!rail) return;
    var tiles = Array.prototype.slice.call(rail.querySelectorAll('.bf-cat-tile'));
    if (!tiles.length) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bf-cat-dot]'));
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseFloat(root.getAttribute('data-speed')) || 4) * 1000;
    var timer = null, resumeT = null, raf = null;

    function padLeft() { return parseFloat(getComputedStyle(rail).paddingLeft) || 0; }
    function scrollable() { return rail.scrollWidth > rail.clientWidth + 4; }
    function currentIndex() {
      var base = rail.scrollLeft + padLeft();
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < tiles.length; i++) {
        var d = Math.abs(tiles[i].offsetLeft - base);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function setActive(i) { for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i); }
    function goTo(i, smooth) {
      var t = tiles[i]; if (!t) return;
      rail.scrollTo({ left: Math.max(0, t.offsetLeft - padLeft()), behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function next() {
      if (!scrollable()) return;
      var i = currentIndex() + 1;
      if (i >= tiles.length) i = 0;
      goTo(i);
    }
    function start() { if (autoplay && scrollable() && !timer) timer = setInterval(next, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var tick = false;
    rail.addEventListener('scroll', function () {
      if (!tick) { tick = true; setTimeout(function () { tick = false; setActive(currentIndex()); }, 60); }
      if (autoplay) { stop(); clearTimeout(resumeT); resumeT = setTimeout(start, 2500); }
    }, { passive: true });

    for (var di = 0; di < dots.length; di++) {
      (function (i) {
        dots[i].addEventListener('click', function () { goTo(i); stop(); clearTimeout(resumeT); resumeT = setTimeout(start, 3000); });
      })(di);
    }

    rail.addEventListener('mouseenter', stop);
    rail.addEventListener('mouseleave', start);
    rail.addEventListener('pointerdown', stop, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    setActive(currentIndex());
    start();
  }

  // Recommandations produit. Shopify ne calcule les suggestions qu'a l'appel
  // de son API de rendu de section : au premier rendu la section sort vide et
  // masquee, et on ne la remplit que lorsqu'elle approche de l'ecran. La fiche
  // ne paie donc rien au chargement.
  // Si Shopify ne renvoie aucun produit, la section RESTE masquee : pas de
  // titre orphelin, pas de blanc, pas de scroll en plus.
  // ---------------- Historique des fiches consultees ----------------
  // Memorise dans le navigateur du visiteur (localStorage), jamais cote
  // serveur. Le handle vient d'un attribut pose par Liquid sur <main> : rien
  // n'est devine de l'URL, et la memorisation marche meme sur une fiche qui
  // n'utiliserait pas bf-product.
  var BF_VUS_CLE = 'bf-vus';
  var BF_VUS_PLAFOND = 12;

  function bfVusLire() {
    try {
      var v = JSON.parse(localStorage.getItem(BF_VUS_CLE) || '[]');
      return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
    } catch (e) { return []; }
  }
  function bfVusEcrire(liste) {
    try { localStorage.setItem(BF_VUS_CLE, JSON.stringify(liste.slice(0, BF_VUS_PLAFOND))); }
    catch (e) { /* navigation privee, quota plein : l'historique est un bonus */ }
  }
  function bfVusHandleCourant() {
    var m = document.querySelector('main[data-bf-vus-handle]');
    return m ? m.getAttribute('data-bf-vus-handle') : null;
  }
  function bfVusMemoriser() {
    var h = bfVusHandleCourant();
    if (!h) return;
    var liste = bfVusLire().filter(function (x) { return x && x !== h; });
    liste.unshift(h);
    bfVusEcrire(liste);
  }

  // Va chercher les fiches de l'historique, une requete par fiche, via une
  // section technique qui ne rend qu'une carte produit. C'est le seul moyen
  // d'obtenir des fiches STRICTEMENT identiques au reste du site : badge,
  // coloris, pointures, achat rapide, apercu rapide.
  function bfVusCartes(sec) {
    if (sec.getAttribute('data-bf-vus') !== '1') return Promise.resolve([]);
    var max = parseInt(sec.getAttribute('data-bf-vus-max'), 10) || 6;
    var racine = sec.getAttribute('data-bf-vus-racine') || '/';
    var courant = bfVusHandleCourant();
    var handles = bfVusLire().filter(function (h) { return h && h !== courant; }).slice(0, max);
    if (!handles.length) return Promise.resolve([]);
    return Promise.all(handles.map(function (h) {
      return fetch(racine + 'products/' + encodeURIComponent(h) + '?section_id=bf-vus-carte')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return null;
          var c = new DOMParser().parseFromString(html, 'text/html').querySelector('.bf-card');
          return c ? c.outerHTML : null;
        })
        .catch(function () { return null; });
    })).then(function (arr) {
      // Purge des produits supprimes ou depublies, en gardant l'ordre.
      var morts = 0;
      for (var i = 0; i < arr.length; i++) { if (!arr[i]) morts++; }
      if (morts) {
        bfVusEcrire(bfVusLire().filter(function (h) {
          var k = handles.indexOf(h);
          return k === -1 ? true : !!arr[k];
        }));
      }
      return arr.filter(Boolean);
    });
  }

  // Fabrique un rail et ses points, a l'identique du rail des suggestions.
  function bfVusRail(modele, cartesHtml, etiquettePoints) {
    var rail = document.createElement('div');
    rail.className = 'bf-rail';
    if (modele) rail.setAttribute('style', modele.getAttribute('style') || '');
    rail.setAttribute('data-bf-carousel', '');
    rail.setAttribute('data-bf-auto', '0');
    rail.setAttribute('data-bf-delay', '0');
    rail.innerHTML = cartesHtml.join('');
    var points = document.createElement('div');
    points.className = 'bf-rail-dots';
    points.setAttribute('data-bf-dots', '');
    points.setAttribute('role', 'tablist');
    points.setAttribute('aria-label', etiquettePoints);
    return { rail: rail, points: points };
  }

  // Deux sources : on passe en onglets. La barre d'onglets REMPLACE le titre
  // au lieu de s'ajouter dessous, et un seul rail reste affiche a la fois :
  // l'historique ne coute donc pas un deuxieme rail de hauteur pleine.
  function bfVusMonterOnglets(sec, cartesHtml) {
    var head = sec.querySelector('.bf-carousel-head');
    var railReco = sec.querySelector('.bf-rail');
    if (!head || !railReco) return false;
    var h2 = head.querySelector('.bf-carousel-heading');
    var titreReco = h2 ? h2.textContent.trim() : '';
    var titreVus = sec.getAttribute('data-bf-vus-titre') || '';
    // Sans deux libelles, une barre d'onglets ne veut rien dire : on renonce
    // et on laisse les suggestions seules.
    if (!titreReco || !titreVus) return false;

    var base = 'bf-panel-' + (sec.id || 'reco');
    var pointsReco = sec.querySelector('.bf-rail-dots');

    var p0 = document.createElement('div');
    p0.className = 'bf-tab-panel is-active';
    p0.id = base + '-0';
    p0.setAttribute('data-bf-panel', '0');
    railReco.parentNode.insertBefore(p0, railReco);
    p0.appendChild(railReco);
    if (pointsReco) p0.appendChild(pointsReco);

    var fabrique = bfVusRail(railReco, cartesHtml, 'Pages des produits vus');
    var p1 = document.createElement('div');
    p1.className = 'bf-tab-panel';
    p1.id = base + '-1';
    p1.setAttribute('data-bf-panel', '1');
    p1.appendChild(fabrique.rail);
    if (pointsReco) p1.appendChild(fabrique.points);
    p0.parentNode.appendChild(p1);

    if (h2 && h2.parentNode) h2.parentNode.removeChild(h2);
    var barre = document.createElement('div');
    barre.className = 'bf-tabs';
    barre.setAttribute('role', 'tablist');
    var onglets = [[titreReco, p0.id, true], [titreVus, p1.id, false]];
    for (var i = 0; i < onglets.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bf-tab' + (onglets[i][2] ? ' is-active' : '');
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', onglets[i][2] ? 'true' : 'false');
      b.setAttribute('aria-controls', onglets[i][1]);
      b.setAttribute('data-bf-tab', String(i));
      b.textContent = onglets[i][0];
      barre.appendChild(b);
    }
    var ind = document.createElement('span');
    ind.className = 'bf-tab-ind';
    ind.setAttribute('data-bf-tab-ind', '');
    ind.setAttribute('aria-hidden', 'true');
    barre.appendChild(ind);
    head.appendChild(barre);
    return true;
  }

  // Aucune suggestion mais un historique : on montre l'historique seul, avec
  // son propre titre. Pas d'onglet unique, ce serait un ornement.
  function bfVusSeul(sec, cartesHtml) {
    var titre = sec.getAttribute('data-bf-vus-titre') || '';
    if (!titre) return false;
    var head = document.createElement('div');
    head.className = 'bf-carousel-head';
    var h2 = document.createElement('h2');
    h2.className = 'bf-carousel-heading';
    h2.textContent = titre;
    head.appendChild(h2);
    sec.appendChild(head);
    var fabrique = bfVusRail(null, cartesHtml, 'Pages des produits vus');
    sec.appendChild(fabrique.rail);
    sec.appendChild(fabrique.points);
    return true;
  }

  function initRecommendations() {
    document.querySelectorAll('[data-bf-pdp-reco]').forEach(function (sec) {
      var url = sec.getAttribute('data-bf-pdp-reco-url');
      if (!url || sec._bfRecoInit) return;
      sec._bfRecoInit = true;
      // La section part masquee : ni taille, ni position. On observe donc la
      // sentinelle de 1px posee juste avant elle, toujours dans le flux --
      // meme schema que le scroll infini des collections.
      var sentinelle = sec.parentNode.querySelector('[data-bf-pdp-reco-sentinel]') || sec;
      var charge = false;
      function charger() {
        if (charge) return;
        charge = true;
        fetch(url)
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var frais = doc.querySelector('[data-bf-pdp-reco]');
            var aDesRecos = !!(frais && frais.querySelector('.bf-card'));
            if (aDesRecos) sec.innerHTML = frais.innerHTML;
            return bfVusCartes(sec).then(function (cartes) {
              var min = parseInt(sec.getAttribute('data-bf-vus-min'), 10) || 2;
              var aDesVus = cartes.length >= min;
              // Ni suggestion ni historique : la section RESTE invisible.
              if (!aDesRecos && !aDesVus) return;
              if (aDesRecos && aDesVus) { bfVusMonterOnglets(sec, cartes); }
              else if (!aDesRecos) { if (!bfVusSeul(sec, cartes)) return; }
              sec.hidden = false;
              // Achat rapide et apercu rapide sont delegues sur document : ils
              // marchent d'office sur ces cartes. Restent le carrousel, les
              // onglets et les videos au survol, lies element par element.
              // Melange AVANT le carrousel : les points comptent les cartes,
              // et on en retire apres coup quand un pool a ete demande.
              initRandomRails(sec);
              sec.querySelectorAll('[data-bf-carousel]').forEach(initRailCarousel);
              initProductTabs(sec);
              initCardVideos(sec);
            });
          })
          .catch(function () { /* silencieux : une suggestion absente n'est pas une panne */ });
      }
      // Deux declencheurs, volontairement. L'observateur est le chemin normal
      // et le moins couteux. Le test de position au scroll est un repli :
      // certains contextes ne livrent jamais les callbacks d'IntersectionObserver
      // (verifie a la main), et une suggestion qui ne se charge jamais est un
      // bug invisible. Le drapeau "charge" empeche le double appel.
      function proche() {
        var r = sentinelle.getBoundingClientRect();
        return r.top <= (window.innerHeight || 0) + 600;
      }
      function auScroll() {
        if (charge) { window.removeEventListener('scroll', auScroll); return; }
        if (proche()) { window.removeEventListener('scroll', auScroll); charger(); }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entrees) {
          entrees.forEach(function (e) {
            if (e.isIntersecting) { io.disconnect(); charger(); }
          });
        }, { rootMargin: '600px 0px' });
        io.observe(sentinelle);
      }
      window.addEventListener('scroll', auScroll, { passive: true });
      auScroll();
    });
  }

  // ---------------- Date de livraison estimee ----------------
  // Calculee dans le NAVIGATEUR, pas en Liquid : une date "commandee
  // aujourd'hui" rendue cote serveur serait figee par le cache de pages de
  // Shopify et pourrait afficher une date perimee.
  // Elle se lit donc sur l'horloge du visiteur. Pour une boutique francaise
  // qui livre en France, c'est le meme fuseau.
  function bfJourOuvre(d, samedi) {
    var j = d.getDay();
    if (j === 0) return false;              // dimanche, jamais
    if (j === 6) return !!samedi;           // samedi, selon le reglage
    return true;
  }
  function bfAjouterJoursOuvres(depart, n, samedi) {
    var d = new Date(depart.getTime());
    var restants = n;
    var garde = 0;
    while (restants > 0 && garde < 400) {
      d.setDate(d.getDate() + 1);
      if (bfJourOuvre(d, samedi)) restants--;
      garde++;
    }
    return d;
  }
  function bfDateFr(d, court) {
    // Format court dans le tiroir du panier : "lun. 31 aout" au lieu de
    // "lundi 31 aout". Sur 375px, la version longue passait sur deux lignes
    // et faisait grossir un pied de tiroir qu'on s'est battu pour garder bas.
    var opts = court
      ? { weekday: 'short', day: 'numeric', month: 'short' }
      : { weekday: 'long', day: 'numeric', month: 'long' };
    try {
      return d.toLocaleDateString('fr-FR', opts);
    } catch (e) {
      return d.getDate() + '/' + (d.getMonth() + 1);
    }
  }
  // Plusieurs blocs possibles : la fiche produit ET le tiroir du panier.
  // Le tiroir etant reconstruit a chaque modification du panier, cette
  // fonction est rappelee apres chaque refonte (voir swapCart).
  function initEtaLivraison() {
    document.querySelectorAll('[data-bf-eta]').forEach(function (el) {
      var cible = el.querySelector('[data-bf-eta-date]');
      if (!cible) return;
      var lire = function (n, defaut) {
        var v = parseInt(el.getAttribute(n), 10);
        return isNaN(v) ? defaut : v;
      };
      var samedi = el.getAttribute('data-samedi') === '1';
      var transitMax = lire('data-transit-max', 0);
      if (transitMax <= 0) return;          // aucun delai saisi : on se tait
      var transitMin = lire('data-transit-min', 0);
      var prepMin = lire('data-prep-min', 0);
      var prepMax = lire('data-prep-max', 0);
      var cutoff = lire('data-cutoff', 14);

      // Point de depart : aujourd'hui. Passe l'heure limite, ou un jour non
      // ouvre, la preparation demarre le jour ouvre suivant.
      var depart = new Date();
      if (depart.getHours() >= cutoff || !bfJourOuvre(depart, samedi)) {
        depart = bfAjouterJoursOuvres(depart, 1, samedi);
      }
      var debut = bfAjouterJoursOuvres(depart, prepMin + transitMin, samedi);
      var fin = bfAjouterJoursOuvres(depart, prepMax + transitMax, samedi);

      var memeJour = debut.toDateString() === fin.toDateString();
      var modele = memeJour
        ? (el.getAttribute('data-texte-jour') || 'le {debut}')
        : (el.getAttribute('data-texte-plage') || 'entre le {debut} et le {fin}');
      var court = el.getAttribute('data-format') === 'court';
      cible.textContent = modele
        .replace('{debut}', bfDateFr(debut, court))
        .replace('{fin}', bfDateFr(fin, court));
      el.hidden = false;
    });
  }

  // Sections depliables de la fiche produit : sur MOBILE elles s'ouvrent en
  // fenetre plutot qu'en place. Deplier en place pousse toute la page vers le
  // bas et fait perdre sa position au visiteur -- le tableau des pointures est
  // le pire cas. En fenetre il lit, referme, et se retrouve au meme endroit.
  // Sur ordinateur la colonne d'infos est deja collante : on n'y touche pas.
  // Le <details> reste dans la page : contenu toujours lu par Google, et la
  // fiche reste utilisable si ce script ne charge pas.
  function initAccordeonsModale() {
    var modale = document.querySelector('[data-bf-accm]');
    if (!modale) return;
    var titre = modale.querySelector('[data-bf-accm-titre]');
    var corps = modale.querySelector('[data-bf-accm-body]');
    var fermeture = modale.querySelector('.bf-accm__close');
    var rendreFocus = null;

    var mobileOn = modale.getAttribute('data-bf-accm-mobile') === 'true';
    var desktopOn = modale.getAttribute('data-bf-accm-desktop') === 'true';
    function surMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }
    // Faut-il ouvrir en fenetre ? Sur mobile -> reglage mobile ; sur ordinateur -> reglage ordinateur.
    function enFenetre() {
      return surMobile() ? mobileOn : desktopOn;
    }

    function ouvrir(acc) {
      var tete = acc.querySelector('.bf-pdp__acc-head span');
      var texte = acc.querySelector('.bf-pdp__acc-body');
      if (!texte) return;
      titre.textContent = tete ? tete.textContent.trim() : '';
      corps.innerHTML = texte.innerHTML;
      corps.scrollTop = 0;
      rendreFocus = acc.querySelector('.bf-pdp__acc-head');
      modale.classList.add('is-open');
      modale.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (fermeture) fermeture.focus();
    }

    function fermer() {
      if (!modale.classList.contains('is-open')) return;
      modale.classList.remove('is-open');
      modale.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (rendreFocus) { rendreFocus.focus(); rendreFocus = null; }
    }

    // Le guide des tailles et d'autres appelants passent par ici.
    modale._bfOuvrir = ouvrir;
    modale._bfSurMobile = surMobile;
    modale._bfEnFenetre = enFenetre;

    // En mode fenetre, aucune section ne doit rester depliee en place : sinon
    // son contenu s'afficherait DEUX fois (dans la page et dans la fenetre),
    // et "Details produit", ouvert par defaut, pousserait deja la page.
    function replierTout() {
      if (!enFenetre()) return;
      document.querySelectorAll('.bf-pdp__acc[open]').forEach(function (a) {
        a.removeAttribute('open');
      });
    }
    replierTout();

    document.addEventListener('click', function (e) {
      var tete = e.target.closest ? e.target.closest('.bf-pdp__acc-head') : null;
      if (!tete || !enFenetre()) return;
      var acc = tete.closest('.bf-pdp__acc');
      if (!acc) return;
      e.preventDefault();   // empeche le <details> de se deplier
      ouvrir(acc);
    });

    modale.querySelectorAll('[data-bf-accm-close]').forEach(function (b) {
      b.addEventListener('click', fermer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) fermer();
    });
    // Repasse sur ordinateur pendant que la fenetre est ouverte : on la ferme,
    // sinon elle resterait bloquee derriere un media query qui la masque.
    window.addEventListener('resize', function () {
      if (!enFenetre()) fermer();
      else replierTout();
    });
  }

  /* ---- Fond automatique des cadres photo ---------------------------------
     530 des 2726 images de la collection femme sont carrees (19 %), dans un
     cadre qui vaut 2500/3609 : elles y laissent 64 px de vide en haut et
     autant en bas. On ne rogne rien, on n'agrandit rien -- on repeint le cadre
     avec la couleur du FOND de la photo pour que les bandes se fondent.
     Si le pourtour n'est pas uni, on ne touche a rien.
     ---------------------------------------------------------------------- */
  function initFondPhoto() {
    var ECART_MAX = 12;    // au-dela, le pourtour n'est pas uni : on renonce
    var TOLERANCE = 0.01;  // en deca, l'image remplit deja le cadre
    var connu = {};        // url -> couleur ou null, resolu
    var attente = {};      // url -> [rappels] pendant l'analyse

    function mediane(t) {
      var c = t.slice().sort(function (a, b) { return a - b; });
      return c[(c.length / 2) | 0];
    }

    function ratioCadre(cadre) {
      var ar = (getComputedStyle(cadre).aspectRatio || '').split('/');
      if (ar.length === 2) {
        var a = parseFloat(ar[0]), b = parseFloat(ar[1]);
        if (a > 0 && b > 0) { return a / b; }
      }
      var r = cadre.getBoundingClientRect();
      return r.height > 0 ? r.width / r.height : 0;
    }

    function ratioImage(img) {
      // Shopify pose width/height sur le <img> : le ratio est connu sans
      // telecharger l'image. C'est ce qui evite d'analyser les 81 % correctes.
      var w = parseFloat(img.getAttribute('width'));
      var h = parseFloat(img.getAttribute('height'));
      if (w > 0 && h > 0) { return w / h; }
      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        return img.naturalWidth / img.naturalHeight;
      }
      return 0;
    }

    function analyser(src, rappel) {
      var cle = src.split('?')[0];
      if (connu[cle] !== undefined) { rappel(connu[cle]); return; }
      if (attente[cle]) { attente[cle].push(rappel); return; }
      attente[cle] = [rappel];

      var fini = function (couleur) {
        connu[cle] = couleur;
        var liste = attente[cle] || [];
        delete attente[cle];
        for (var i = 0; i < liste.length; i++) { liste[i](couleur); }
      };

      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        var couleur = null;
        try {
          var c = document.createElement('canvas');
          c.width = im.naturalWidth;
          c.height = im.naturalHeight;
          var ctx = c.getContext('2d');
          ctx.drawImage(im, 0, 0);
          var d = ctx.getImageData(0, 0, c.width, c.height).data;
          var W = c.width - 1, H = c.height - 1;
          var mx = (W / 2) | 0, my = (H / 2) | 0;
          var pts = [[1, 1], [W - 1, 1], [1, H - 1], [W - 1, H - 1],
                     [mx, 1], [mx, H - 1], [1, my], [W - 1, my]];
          var rs = [], gs = [], bs = [], i, k, ok = true;
          for (i = 0; i < pts.length; i++) {
            k = (pts[i][1] * c.width + pts[i][0]) * 4;
            if (d[k + 3] < 250) { ok = false; break; }  // bord transparent
            rs.push(d[k]); gs.push(d[k + 1]); bs.push(d[k + 2]);
          }
          if (ok) {
            // Juger par rapport a la MEDIANE, pas entre les extremes : l'ombre
            // portee d'un produit touche souvent un bord et fait chuter UN
            // point. Mesure sur 909.jpg : 7 points entre 252 et 255, le 8e a
            // 243 -- l'ecart entre extremes atteignait 14 et rejetait une photo
            // manifestement blanche. La mediane, elle, ne bouge pas.
            var mr = mediane(rs), mg = mediane(gs), mb = mediane(bs);
            var proches = 0;
            for (i = 0; i < rs.length; i++) {
              if (Math.abs(rs[i] - mr) <= ECART_MAX
               && Math.abs(gs[i] - mg) <= ECART_MAX
               && Math.abs(bs[i] - mb) <= ECART_MAX) { proches++; }
            }
            // 6 sur 8 : un decor ou un degrade disperse trop les points pour
            // atteindre ce compte, et rien ne sera repeint.
            if (proches >= 6) {
              couleur = 'rgb(' + mr + ', ' + mg + ', ' + mb + ')';
            }
          }
        } catch (e) {
          couleur = null;  // canvas bloque : on renonce en silence
        }
        fini(couleur);
      };
      im.onerror = function () { fini(null); };
      im.src = cle + '?width=120';
    }

    function traiter(cadre) {
      if (cadre.getAttribute('data-bf-fond')) { return; }
      var rc = ratioCadre(cadre);
      if (!rc) { return; }  // pas encore mis en page : on repassera
      cadre.setAttribute('data-bf-fond', '1');

      var origine = getComputedStyle(cadre).backgroundColor;
      var survol = cadre.querySelector('img.bf-card__img--hover');
      var principale = null;
      var imgs = cadre.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i] !== survol) { principale = imgs[i]; break; }
      }

      var etat = { un: null, deux: null, restant: 0, trouve: false };

      var poser = function () {
        if (etat.restant > 0 || !etat.trouve) { return; }
        cadre.style.setProperty('--bf-fond-1', etat.un || origine);
        cadre.style.setProperty('--bf-fond-2', etat.deux || etat.un || origine);
        cadre.classList.add('bf-fond-auto');
      };

      var examiner = function (img, rang) {
        if (!img) { return; }
        var ri = ratioImage(img);
        if (!ri || Math.abs(ri - rc) < TOLERANCE) { return; }  // remplit le cadre
        var src = img.currentSrc || img.getAttribute('src');
        if (!src) { return; }
        etat.restant++;
        analyser(src, function (couleur) {
          if (couleur) {
            etat.trouve = true;
            if (rang === 1) { etat.un = couleur; } else { etat.deux = couleur; }
          }
          etat.restant--;
          poser();
        });
      };

      // La photo principale REMPLIT le cadre ; une photo de survol carree n'en
      // couvre que la bande centrale. Sans masquer la principale, les deux
      // photos s'affichent ensemble et 64,5 px de la principale depassent en
      // haut et en bas -- exactement ce que montrait la capture de Michael.
      // Pose des maintenant : cela ne depend pas de l'analyse de couleur.
      if (survol) {
        var rSurvol = ratioImage(survol);
        if (rSurvol && Math.abs(rSurvol - rc) >= TOLERANCE) {
          cadre.classList.add('bf-fond-survol');
        }
      }

      examiner(principale, 1);
      examiner(survol, 2);
    }

    function scanner() {
      var cadres = document.querySelectorAll('.bf-card__media, .bf-pdp__media-item');
      for (var i = 0; i < cadres.length; i++) { traiter(cadres[i]); }
    }

    scanner();
    window.addEventListener('load', scanner);

    // Le scroll infini des collections ajoute des cartes apres coup, et les
    // onglets des carrousels en revelent d'autres. On rescanne, en differe.
    if (window.MutationObserver) {
      var minuteur = null;
      new MutationObserver(function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(scanner, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---- Univers "Toute la famille" : la video ne joue qu'au survol ---------
     Elle n'est ni jouee ni telechargee tant que personne ne survole : le
     Liquid pose autoplay: false et preload metadata, et le CSS la retire du
     rendu sous 900 px. Retour a zero a la sortie, pour que le survol suivant
     reparte du debut.
     ---------------------------------------------------------------------- */
  function initVideosUnivers() {
    // Deux sections, meme geste : tuile d'univers et panneau. Les separer
    // aurait donne deux comportements de survol legerement differents pour
    // deux blocs qui se ressemblent a l'ecran.
    var familles = [
      ['.bf-cat-tile', '.bf-cat-tile__video video'],
      ['.bf-panneau', '.bf-panneau__video video']
    ];
    familles.forEach(function (paire) {
      document.querySelectorAll(paire[0]).forEach(function (tuile) {
        var v = tuile.querySelector(paire[1]);
        if (!v) { return; }
        tuile.addEventListener('mouseenter', function () {
          var p = v.play();
          // play() rejette si le navigateur refuse : on avale, sinon la console
          // se remplit d'erreurs non gerees.
          if (p && p.catch) { p.catch(function () {}); }
        });
        tuile.addEventListener('mouseleave', function () {
          v.pause();
          try { v.currentTime = 0; } catch (e) {}
        });
      });
    });
  }

  /* ---- Fiche produit : la video part au survol, pas au clic ---------------
     Le Liquid la pose sans controles et sans autoplay. Ici on la lance : au
     SURVOL sur ordinateur, et a l'APPARITION A L'ECRAN sur telephone, ou le
     survol n'existe pas. Sans ce second chemin, une video sans controles
     serait injouable au doigt.
     ---------------------------------------------------------------------- */
  function initVideosFiche() {
    var videos = document.querySelectorAll('.bf-pdp__video');
    if (!videos.length) { return; }

    var lancer = function (v) {
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
    };

    videos.forEach(function (v) {
      var cadre = v.closest('.bf-pdp__media-item') || v;
      cadre.addEventListener('mouseenter', function () { lancer(v); });
      cadre.addEventListener('mouseleave', function () { v.pause(); });
      // Un doigt sur la video la lance aussi : sans controles, c'est le seul
      // geste disponible si l'observateur n'a pas encore declenche.
      cadre.addEventListener('click', function () {
        if (v.paused) { lancer(v); } else { v.pause(); }
      });
    });

    if (!('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        var v = entrees[i].target;
        if (entrees[i].isIntersecting) { lancer(v); } else { v.pause(); }
      }
    }, { threshold: 0.6 });
    // "Video sur mobile" decoche : plus de lecture a l'apparition sous 900 px.
    // Le survol sur ordinateur reste branche, c'est un autre geste.
    var petitEcran = window.innerWidth < 900;
    videos.forEach(function (v) {
      if (petitEcran && v.closest && v.closest('.bf-pdp--sans-video-m')) { return; }
      io.observe(v);
    });
  }

  /* ---- Carrousels mobile : lancer la video de la carte visible -------------
     Un rail peut contenir dix produits. Les lancer toutes ferait decoder dix
     videos a la fois sur un telephone -- batterie, data et fluidite. On n'en
     joue qu'une : celle qu'on regarde. Seuil 0,6, soit la carte
     majoritairement visible.
     Ne s'applique QUE sous 900 px, et seulement aux sections ou Michael a
     coche le reglage.
     ---------------------------------------------------------------------- */
  function initVideosCartesMobile() {
    if (window.innerWidth >= 900) { return; }

    // Cartes produit ET tuiles d'univers : meme regle, meme observateur.
    var SEL = '.bf-cards-m--video .bf-card__video'
      + ', .bf-cat--video-m .bf-cat-tile__video video'
      + ', [data-bf-panneaux-video="1"] .bf-panneau__video video';
    var suivies = [];

    var jouer = function (v) {
      var p = v.play();
      // play() rejette si le navigateur refuse : on avale, sinon la console se
      // remplit d'erreurs non gerees.
      if (p && p.catch) { p.catch(function () {}); }
    };

    // La bascule photo -> video se fait sur "playing", donc quand des images
    // defilent VRAIMENT. Sur "play" on basculerait trop tot : en preload
    // "none" il n'y a encore rien a montrer, et une lecture refusee laisserait
    // un cadre vide a la place de la photo portee.
    var suivrePhoto = function (v) {
      if (v._bfBascule) { return; }
      v._bfBascule = true;
      var carte = v.closest ? v.closest('.bf-card') : null;
      if (!carte) { return; }
      v.addEventListener('playing', function () { carte.classList.add('is-video-on'); });
      v.addEventListener('pause', function () { carte.classList.remove('is-video-on'); });
      v.addEventListener('ended', function () { carte.classList.remove('is-video-on'); });
    };

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entrees) {
        for (var i = 0; i < entrees.length; i++) {
          if (entrees[i].isIntersecting) { jouer(entrees[i].target); }
          else { entrees[i].target.pause(); }
        }
      }, { threshold: 0.6 });
    }

    // Filet : l'observateur ne parle qu'au franchissement du seuil, et il reste
    // muet la ou le navigateur ne compose aucune image (mesure faite : play()
    // accepte, observateur neuf jamais declenche). Ce controle direct, lui, ne
    // depend d'aucun mecanisme differe.
    var verifier = function () {
      var h = window.innerHeight || document.documentElement.clientHeight;
      var w = window.innerWidth || document.documentElement.clientWidth;
      for (var i = 0; i < suivies.length; i++) {
        var v = suivies[i];
        var r = v.getBoundingClientRect();
        if (!r.height || !r.width) { continue; }
        // Les DEUX axes, comme IntersectionObserver. Sur la seule verticale,
        // un rail horizontal lancait ses dix videos d'un coup : mesure faite,
        // 8 en lecture simultanee dont une a left = -702.
        var visibleY = Math.min(r.bottom, h) - Math.max(r.top, 0);
        var visibleX = Math.min(r.right, w) - Math.max(r.left, 0);
        var part = 0;
        if (visibleY > 0 && visibleX > 0) {
          part = (visibleY * visibleX) / (r.height * r.width);
        }
        if (part >= 0.6) { if (v.paused) { jouer(v); } }
        else if (!v.paused) { v.pause(); }
      }
    };

    var scanner = function () {
      var videos = document.querySelectorAll(SEL);
      for (var i = 0; i < videos.length; i++) {
        if (videos[i]._bfMobileObs) { continue; }
        videos[i]._bfMobileObs = true;
        suivies.push(videos[i]);
        suivrePhoto(videos[i]);
        if (io) { io.observe(videos[i]); }
      }
      verifier();
    };
    scanner();

    var attente = null;
    var differer = function () { clearTimeout(attente); attente = setTimeout(verifier, 120); };
    window.addEventListener('scroll', differer, { passive: true });
    window.addEventListener('resize', differer);

    // Des cartes arrivent APRES le premier rendu : scroll infini de la page
    // collection, changement d'onglet des carrousels, "Vus recemment" charge en
    // AJAX. Sans ce rescan, la video partirait en haut de page et plus du tout
    // en bas -- exactement le genre de panne qu'on ne voit qu'au telephone.
    if (window.MutationObserver) {
      var minuteur = null;
      new MutationObserver(function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(scanner, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  // "Voir plus" : deplie la seconde ligne de produits d'un carrousel.
  // On bascule l'attribut hidden -- le CSS le rend plus fort que display:grid.
  function initVoirPlus() {
    document.querySelectorAll('[data-bf-plus]').forEach(function (b) {
      if (b._bfPlus) { return; }
      b._bfPlus = true;
      b.addEventListener('click', function () {
        var cible = document.getElementById(b.getAttribute('aria-controls'));
        if (!cible) { return; }
        var etaitOuvert = !cible.hidden;
        cible.hidden = etaitOuvert;
        b.setAttribute('aria-expanded', etaitOuvert ? 'false' : 'true');
        // On ne reecrit QUE le texte cache : b.textContent effacerait la
        // fleche, qui est un SVG enfant du bouton.
        var libelle = etaitOuvert ? b.getAttribute('data-libelle-plus')
                                  : b.getAttribute('data-libelle-moins');
        var txt = b.querySelector('[data-bf-plus-txt]');
        if (txt && libelle) { txt.textContent = libelle; }
      });
    });
  }

  /* ---- Panneaux : la bande avance toute seule sur mobile ------------------
     Ne demarre que si la bande est REELLEMENT defilante : sur ordinateur les
     panneaux tiennent dans la largeur, donc rien ne bouge, et on n'a pas
     besoin de tester la taille de l'ecran.
     ---------------------------------------------------------------------- */
  function initPanneauxAuto() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    document.querySelectorAll('[data-bf-panneaux-auto="1"]').forEach(function (sec) {
      var rail = sec.querySelector('.bf-panneaux__rail');
      if (!rail || rail._bfAuto) { return; }
      rail._bfAuto = true;

      var panneaux = [].slice.call(rail.querySelectorAll('.bf-panneau'));
      if (panneaux.length < 2) { return; }
      var vitesse = (parseFloat(sec.getAttribute('data-bf-panneaux-vitesse')) || 4) * 1000;
      var minuteur = null, reprise = null, nousMemes = false, relache = null;

      function defilable() { return rail.scrollWidth > rail.clientWidth + 4; }
      function marge() { return parseFloat(getComputedStyle(rail).paddingLeft) || 0; }
      function courant() {
        var base = rail.scrollLeft + marge(), best = 0, ecart = Infinity;
        for (var i = 0; i < panneaux.length; i++) {
          var d = Math.abs(panneaux[i].offsetLeft - base);
          if (d < ecart) { ecart = d; best = i; }
        }
        return best;
      }
      function suivant() {
        if (!defilable()) { return; }
        var i = courant() + 1;
        if (i >= panneaux.length) { i = 0; }
        var p = panneaux[i];
        // Notre propre defilement ne doit pas passer pour un geste du
        // visiteur, sinon le minuteur s'arrete a chaque pas qu'on vient de
        // faire et la bande n'avance plus qu'une fois sur deux.
        nousMemes = true;
        clearTimeout(relache);
        relache = setTimeout(function () { nousMemes = false; }, 700);
        var cible = Math.max(0, p.offsetLeft - marge());
        var depart = rail.scrollLeft;
        try { rail.scrollTo({ left: cible, behavior: 'smooth' }); }
        catch (e) { rail.scrollLeft = cible; }
        // Filet : certains contextes ignorent le defilement doux -- onglet en
        // arriere-plan, reglage systeme, navigateur ancien. Sans lui la bande
        // resterait immobile sans que rien ne le signale.
        setTimeout(function () {
          if (Math.abs(rail.scrollLeft - depart) < 2 && Math.abs(cible - depart) > 2) {
            rail.scrollLeft = cible;
          }
        }, 420);
      }
      function demarrer() { if (!minuteur && defilable()) { minuteur = setInterval(suivant, vitesse); } }
      function arreter() { if (minuteur) { clearInterval(minuteur); minuteur = null; } }

      // Le visiteur reprend la main : on s'arrete, et on ne repart que 2,5 s
      // apres son dernier geste.
      rail.addEventListener('scroll', function () {
        if (nousMemes) { return; }
        arreter();
        clearTimeout(reprise);
        reprise = setTimeout(demarrer, 2500);
      }, { passive: true });

      window.addEventListener('resize', function () { arreter(); demarrer(); });
      demarrer();
      // Au tout premier appel la mise en page peut ne pas etre stabilisee : la
      // bande n'est alors pas encore declaree defilante, et rien ne la
      // relancerait jamais. On retente une fois.
      setTimeout(demarrer, 1200);
    });
  }

  function init() {
    initQuickAdd();
    initVoirPlus();
    initPanneauxAuto();
    bfVusMemoriser();
    initEtaLivraison();
    initAccordeonsModale();
    initRecommendations();
    initProduct();
    initBundle();
    initOptions();
    document.querySelectorAll('[data-bf-cat-carousel]').forEach(initCatCarousel);
    initCartDrawer();
    initSearch();
    initLang();
    initRandomRails();
    initStickyEtToTop();
    initVideosUnivers();
    initVideosFiche();
    initVideosCartesMobile();
    initFondPhoto();
    initZoom();
    initReassurance();
    initFooterCols();
    document.querySelectorAll('[data-bf-carousel]').forEach(initRailCarousel);
    initRandomMegaCards();
    initQuickView();
    document.querySelectorAll('[data-bf-hero]').forEach(initHeroSlider);
    document.querySelectorAll('.bf-header').forEach(function (header) {
      initHeader(header.closest('.bf-home') || header.parentElement);
    });
    document.querySelectorAll('.bf-carousel-section').forEach(initProductTabs);
    initCardVideos();
    document.querySelectorAll('.bf-lookbook').forEach(initLookbook);
    document.querySelectorAll('.bf-size-range').forEach(initSplit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Page COLLECTION — tiroir de filtres, tri auto, affichage 3/4.
   L'achat rapide et l'apercu rapide fonctionnent deja via la
   delegation au niveau document du bloc principal (rien a ajouter).
   ============================================================ */
(function () {
  function initCollection() {
    var root = document.querySelector('[data-bf-coll]');
    if (!root) return;

    var form = root.querySelector('[data-bf-coll-form]');

    /* --- Tiroir de filtres (meme mecanique que le tiroir panier) --- */
    var drawer = root.querySelector('[data-bf-collf]');
    if (drawer) {
      var openBtn = root.querySelector('[data-bf-collf-open]');
      var escF = function (e) { if (e.key === 'Escape') closeF(); };
      var openF = function () {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', escF);
      };
      var closeF = function () {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', escF);
      };
      if (openBtn) openBtn.addEventListener('click', openF);
      drawer.querySelectorAll('[data-bf-collf-close]').forEach(function (el) {
        el.addEventListener('click', closeF);
      });
    }

    /* --- Champs prix vides desactives avant envoi (URL propre) --- */
    if (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('.bf-collf__price input').forEach(function (i) {
          if (!i.value.trim()) i.disabled = true;
        });
      });
    }

    /* --- Tri : soumission automatique du formulaire --- */
    var sort = root.querySelector('[data-bf-sort]');
    if (sort && form) {
      sort.addEventListener('change', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    /* --- Colonnes choisies par le visiteur (ordinateur et/ou mobile) ---
       Les boutons rendus par le Liquid font foi : leurs valeurs sont les
       bornes reglees dans l'editeur. --- */
    var grid = root.querySelector('[data-bf-coll-grid]');
    var remember = root.getAttribute('data-remember') !== 'off';

    var bindCols = function (attr, cssVar, storeKey, prefere) {
      var btns = root.querySelectorAll('[' + attr + ']');
      if (!btns.length) return;

      var valeurs = [];
      for (var v = 0; v < btns.length; v++) valeurs.push(btns[v].getAttribute(attr));

      var apply = function (n) {
        n = String(n);
        if (grid) grid.style.setProperty(cssVar, n);
        for (var i = 0; i < btns.length; i++) {
          btns[i].classList.toggle('is-active', btns[i].getAttribute(attr) === n);
        }
        if (remember) { try { localStorage.setItem(storeKey, n); } catch (e) {} }
      };

      for (var j = 0; j < btns.length; j++) {
        (function (b) {
          b.addEventListener('click', function () { apply(b.getAttribute(attr)); });
        })(btns[j]);
      }

      var memo = null;
      if (remember) { try { memo = localStorage.getItem(storeKey); } catch (e) {} }
      // On n'applique qu'une valeur reellement proposee, sinon aucun bouton ne
      // serait actif et la grille afficherait un nombre inexplique.
      var choix = null;
      if (memo && valeurs.indexOf(memo) >= 0) choix = memo;
      else if (prefere && valeurs.indexOf(String(prefere)) >= 0) choix = String(prefere);
      else choix = valeurs[0];
      apply(choix);
    };

    bindCols('data-bf-viewby', '--bf-coll-cols', 'bf-coll-cols', root.getAttribute('data-cols'));
    bindCols('data-bf-viewby-m', '--bf-coll-cols-m', 'bf-coll-cols-m', root.getAttribute('data-cols-m'));

    /* --- Chargement de la suite : defilement infini ou bouton "Voir plus" --- */
    var more = root.querySelector('[data-bf-more]');
    var pager = root.querySelector('[data-bf-pager]');
    if (more && grid && 'fetch' in window && window.DOMParser) {
      var mode = more.getAttribute('data-bf-mode') || 'infinite';
      var btn = more.querySelector('[data-bf-more-btn]');
      var shown = more.querySelector('[data-bf-shown]');
      var nextUrl = more.getAttribute('data-next-url');
      var io2 = null;
      var loading = false;

      // Le chargement dynamique remplace la pagination numerotee. Chaque repli
      // ci-dessous la redonne : sans elle, le reste du catalogue serait perdu.
      if (pager) pager.hidden = true;

      var stop = function () {
        if (io2) io2.disconnect();
        if (btn) btn.hidden = true;
        var spin = more.querySelector('[data-bf-more-spin]');
        if (spin && spin.parentNode) spin.parentNode.removeChild(spin);
        // Plus rien a charger : on garde le bloc s'il porte encore le compteur.
        if (!shown && more.parentNode) more.parentNode.removeChild(more);
      };

      var loadMore = function () {
        if (loading || !nextUrl) return;
        loading = true;
        more.classList.add('is-loading');
        if (btn) btn.disabled = true;
        fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('[data-bf-coll-grid] .bf-card');
            for (var i = 0; i < cards.length; i++) {
              grid.appendChild(document.importNode(cards[i], true));
            }
            var ns = doc.querySelector('[data-bf-more]');
            nextUrl = ns ? ns.getAttribute('data-next-url') : null;
            loading = false;
            more.classList.remove('is-loading');
            if (btn) btn.disabled = false;
            if (shown) shown.textContent = grid.querySelectorAll('.bf-card').length;
            if (!nextUrl) stop();
          })
          .catch(function () {
            loading = false;
            more.classList.remove('is-loading');
            if (btn) btn.disabled = false;
            if (pager) pager.hidden = false;
          });
      };

      if (!nextUrl) {
        stop();
      } else if (mode === 'button' && btn) {
        btn.addEventListener('click', loadMore);
      } else if ('IntersectionObserver' in window) {
        io2 = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { loadMore(); break; }
          }
        }, { rootMargin: '700px 0px' });
        io2.observe(more);
      } else if (pager) {
        pager.hidden = false;
      }
    }

    /* --- Barre collante : le decalage vaut la hauteur MESUREE de l'en-tete,
       jamais une constante -- l'en-tete est plus court sur mobile. --- */
    var stickyBar = root.querySelector('[data-bf-coll-sticky]');
    if (stickyBar) {
      var header = document.querySelector('.bf-header');
      var setTop = function () {
        var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
        stickyBar.style.setProperty('--bf-coll-bar-top', h + 'px');
      };
      setTop();
      window.addEventListener('resize', setTop);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollection);
  } else {
    initCollection();
  }
})();

/* ============================================================
   Prechargement de la navigation -- REPLI seulement.
   Chrome et Edge suivent les regles de speculation posees dans theme.liquid.
   Safari et Firefox ne les connaissent pas : pour eux, on pose un
   <link rel="prefetch"> au survol et au premier contact du doigt. Le test de
   support evite de faire le travail deux fois la ou il est deja fait.
   ============================================================ */
(function () {
  var geresParLeNavigateur = !!(window.HTMLScriptElement
    && HTMLScriptElement.supports
    && HTMLScriptElement.supports('speculationrules'));
  if (geresParLeNavigateur) { return; }
  if (!('fetch' in window)) { return; }

  // Connexion menagee : sur un forfait limite ou en 2G, on ne precharge rien.
  var co = navigator.connection;
  if (co && (co.saveData || /2g/.test(co.effectiveType || ''))) { return; }

  var faits = {};
  var EXCLUS = /\/(cart|checkouts?|account|localization)(\/|$|\?)/;

  var precharger = function (a) {
    if (!a || !a.href || a.target === '_blank') { return; }
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return; }
    if (u.origin !== location.origin) { return; }
    if (u.pathname === location.pathname) { return; }
    if (EXCLUS.test(u.pathname)) { return; }
    if (a.hasAttribute('data-sans-prefetch')) { return; }
    var cle = u.href;
    if (faits[cle]) { return; }
    faits[cle] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = cle;
    document.head.appendChild(l);
  };

  var depuis = function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a) { precharger(a); }
  };

  document.addEventListener('mouseover', depuis, { passive: true });
  document.addEventListener('touchstart', depuis, { passive: true });
})();
